<template>
<div class="ol-map mymap" :id="id" :class="{ footer_opened: $store.state.footer.active, footer_closed: !$store.state.footer.active }">

  <notifications class="search-help-notification" group="search-help-notification" position="top center">
    <template slot="body" slot-scope="props">
      <div class="notification vue-notification warn" @click="dontShowAnymoreSearchHelpNotification">
         <div class="notification-content"><div v-html="props.item.text"></div></div>
       </div>
     </template>
  </notifications>

  <notifications class="search-help-notification" group="info-pnse-notification" position="top center">
    <template slot="body" slot-scope="props">
      <div class="notification vue-notification warn">
         <div class="notification-content" @click="closeInfoPnseNotification"><div v-html="props.item.text"></div></div>
         <div class="notification-content" @click="dontShowAnymoreInfoPnseNotification">
           <u>{{ $t("message['J ai compris, ne plus voir cette information.']") }}</u>
         </div>
       </div>
     </template>
  </notifications>

  <!-- Modal content pnse Notification -->
  <div id="pnse-notification" class="tools_modal">
    <div class="tools_modal_content tools_modal_content_pnse">
      <button class="tools_modal_close" @click="close('pnse-notification')"></button>
      <div class="tools_modal_header tools_modal_header_pnse">
      </div>
      <div class="pnse-notification-dialog-content">
        <div class="tools_modal_text" v-html="notifPNSE">
        </div>
      </div>
      <div class="tools_modal_footer tools_modal_footer_pnse">
        <div class="modal-dialog-buttons">
          <button class="fermer" @click="close('pnse-notification')">{{ $t("message['Fermer']") }}</button>
          <button class="enregistrer" @click="dontShowAnymoreInfoPnseNotification">{{ $t("message['J ai compris, ne plus voir cette information.']") }}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="warning" :style="{ display: this.showWarning ? 'block' : 'none' }">
    <div>
      <img v-if="supportsVisible && supportsMaxDensityReached" style="height:12px;" src="../assets/img/SUP_X.svg" alt="sup" />
      <img v-if="mesuresVisible && mesuresMaxDensityReached" style="height:12px;" src="../assets/img/MES_X.svg" alt="mes" />
      <img v-if="simulationsVisible && currentZoom<this.ZOOM_MINIMUM_COEXYA" style="height:12px;" src="../assets/img/legende_horizontale.png" alt="simu" />
      ➞ {{ $t("message['Veuillez zoomer']") }}</div>
  </div>

  <!-- Fiches placées ici pour qu'elles soient visibles en plein écran -->
  <fiche-support ref="ficheSupport"></fiche-support>
  <fiche-mesure ref="ficheMesure"></fiche-mesure>

  <div style="display: none;">
    <div id="location-marker" class="location-marker"></div>
  </div>
  <div style="display: none;">
    <div id="lonlat-marker" class="lonlat-marker"></div>
  </div>

  <div class="hideFicheAntenne">
    <div class="showficheAntenne" id="ficheantennePopup">
      <div class="modal_wrap_ficheAntenne">
        <div class="modal_all_content" id="ficheantenneContent">
        <label for="modal_trigger" @click="close" class="close_modal labelFicheAntenne"></label>
        </div>
      </div>
    </div>
  </div>

  <div class="map_tools" style="width: 100%; height: 100%">
    <div class="top_left">
      <search-adresse class="map_search_bar" @lonlat="lonlat" @changeLocalisation="disableFilterLocalisation" Home='false'></search-adresse>
    </div>

    <div class="bottom_left">
      <div class="line">
        <!-- Changer Fonds de carte -->
        <div class="bgmaps">
          <button class="change_background" :class="{ planIGN: $store.state.ign==layerGeo, planOSM: $store.state.ign==layerOpenStreet}" @click="switchIgnLayer"></button>
        </div>
        <!-- Echelle -->
        <div class="scale">
          <div id="crMapInfo">
            <div id="scaleContainer" />
          </div>
        </div>
      </div>
      <!-- Date maj données carto -->
      <div class="line" style="width: 250px;">
        <p class="date_maj"></p>
      </div>
    </div>

    <div class="middle" :class="{showscroll: boolShowStats && $store.state.sidebar.active , show : boolShowStats}" id="stats">
      <div class="stats_modal_content" :class="{showDetail: boolShowDetail}">
        <div class="stats_close">
          <button class="btn_stats_close" @click="closeStats"></button>
        </div>
        <div class="titre_stats">
          <div class="img_stats">
            <img class="img_graph_titre" src="../assets/img/graph.svg">
          </div>
          <div class="text_titre">
            <div class="titre">
              {{ $t("message['Comptage des sites radioélectriques']") }}
            </div>
            <div class="sousTitre">
              {{$store.state.localisation.filter != null ? $store.state.localisation.filter.nom.toLowerCase() : null}}
            </div>
          </div>
        </div>
        <!--Button pour l'export en csv-->
        <div class="stats_export">
          <button class="btn_stats_export" @click="exportStatsDataToCsv"><img src="@/assets/img/texte/export.png" class="symbole"/>{{ $t("message['Exporter les données']") }}</button>
        </div>
        <!---->
        <div class="stats_box" :class="{inactive: boolShowDetail}">
          <div class="box_total">
            <div class="box_total_detail">
              <div class="title_box">
                {{ $t("message['Total des sites']") }}
              </div>
              <div class="number_box">
                {{totalSites}}
              </div>
              <div class="text_box">
                {{ $t("message['Le total des sites ci-dessus']") }}
              </div>
            </div>
          </div>
          <div class="box_categories">
            <div class="box_spec box_tel" :class="{inactive: !$store.state.supports.categories.TEL.show}" @click="showDetail">
              <div class="title_box">
                {{ $t("message['Téléphonie mobile']") }}
              </div>
              <div class="number_box">
                {{nbTel}}
              </div>
              <div class="button_box">
                <button>Détails</button>
              </div>
              <div class="detail_hover">
                <img class="img_details" src="../assets/img/detail-access.svg">
                <p>{{ $t("message['Accéder au détail']") }}</p>
              </div>
            </div>
            <div class="box_spec box_tv" :class="{inactive: !$store.state.supports.categories.TNT.show}">
              <div class="title_box">
                {{ $t("message['TV']") }}
              </div>
              <div class="number_box">
                {{nbTv}}
              </div>
            </div>
            <div class="box_spec box_radio image" :class="{inactive: !$store.state.supports.systemes.FM.show && !$store.state.supports.systemes.AM.show && !$store.state.supports.systemes.RNT.show}">
              <div class="title_box">
                {{ $t("message['Radio']") }}
              </div>
              <div class="number_box">
                {{nbRadio}}
              </div>
            </div>
            <div class="box_spec box_rmp" :class="{inactive: !$store.state.supports.categories.PMR.show}">
              <div class="title_box">
                {{ $t("message['Réseaux mobiles privés']") }}
              </div>
              <div class="number_box">
                {{nbRmp}}
              </div>
            </div>
            <div class="box_spec box_fh" :class="{inactive: !$store.state.supports.categories.FH.show}">
              <div class="title_box">
                {{ $t("message['Faisceaux Hertziens']") }}
              </div>
              <div class="number_box">
                {{nbFh}}
              </div>
            </div>
            <div class="box_spec box_autres" :class="{inactive: !$store.state.supports.categories.AUTRES.show}">
              <div class="title_box">
                {{ $t("message['Autres stations']") }}
              </div>
              <div class="number_box">
                {{nbAutres}}
              </div>
            </div>
          </div>
        </div>
        <!-- Partie du détail par opérateur -->
        <div class="detail_operateur" :class="{active: boolShowDetail}">
          <div class="box_detail_tel">
            <div class="title_box_detail">
              {{ $t("message['Téléphonie mobile']") }}
            </div>
            <div class="number_box_detail">
              {{nbTel}}
            </div>
            <div class="text_sites_autorises_tel">
              {{ $t("message['sites']") }}
            </div>
            <div class="text_sites_service">
              {{ $t("message['dont']") + " " + nbTelService + " " + $t("message['en service']") }}
            </div>
          </div>
          <div class="box_detail_operateur" :class="{active: boolShowDetail}">
            <div class="retour" :class="{active: boolShowDetail}">
              <div class="retour_content" @click="hideDetail">
                <img class="img_arrow_left" src="../assets/img/arrow-left.svg">
                {{ $t("message['Retour']") }}
              </div>
            </div>
            <div class="box_detail_operateur_content">
              <div class="header_detail_operateur">
                <div class="title_detail_operateur">
                  {{ $t("message['Détail par opérateur']") }}
                  <br/>
                  <span class="subtitle_detail_operateur" :class="{active: boolShowTechnos || boolShowTechnosBandes}">{{ $t("message['Tous les sites | Sites en service']") }}</span>
                </div>
                <div class="box_btn_technologies">
                  <div class="btn_technologies" :class="{active: boolShowTechnos}" @click="showTechnos">
                    {{ $t("message['Technologies']") }}
                  </div>
                  <div class="btn_technologies btnBande" :class="{active: boolShowTechnosBandes}" @click="showTechnosBandes">
                    {{ $t("message['Technologies + Bandes de fréquences']") }}
                  </div>
                </div>
              </div>
              <div class="content_detail_operateur">
                <div class="boxes_operateurs" :class="{inactive: boolShowTechnos || boolShowTechnosBandes}">
                  <div v-for="(operateur, index) in (operateurData)" :key="index" class="box_operateur" :style="{'color': operateur.code_couleur}" >
                    <div class="img_operateur">
                        <img :src="`/static/img/operateurs/logos/logo-${operateur.id}.png`" :alt="operateur.nom" :title="operateur.nom">
                    </div>
                    <div class="nb_operateur">
                      {{operateur.count}}
                    </div>
                    <div class="text_sites_autorises">
                      {{ $t("message['sites']") }}
                    </div>
                    <div class="ligne"></div>
                    <div class="text_sites_service" :style="{'color': operateur.code_couleur}">
                      {{ $t("message['dont']") + " " + operateur.countEnService + " " + $t("message['en service']") }}
                    </div>
                  </div>
                </div>
                <div class="detail_technos" :class="{active: boolShowTechnos}">
                  <table class="tab_technos">
                    <thead>
                      <tr>
                        <th></th>
                        <th v-for="(operateur, index) in operateurData" :key="index" ><img :src="`/static/img/operateurs/logos/logo-${operateur.id}.png`" :alt="operateur.nom" :title="operateur.nom" ></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(operateurTechno, index) in this.listeOperateurTechno" :key="index" class="trTechno" :class="{technoPair: index % 2 == 0}" >
                        <td class="tdTechno">{{operateurTechno.technologie}}</td>
                        <td v-for="(operateur, index) in operateurData" :key="index" class="tdCount" :style="{'background-color': addAlpha(operateur.code_couleur, 0.1), 'color' : operateur.code_couleur}">
                          <div v-if="findDataOperateur(operateurTechno.operateurCount,operateur)">
                              <span class="countOperateurTechno">{{ findDataOperateur(operateurTechno.operateurCount,operateur).count }}</span> {{' | ' + findDataOperateur(operateurTechno.operateurCount,operateur).countService}}
                            </div>
                            <div v-else> {{'-'}} </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="detail_technos_bandes" :class="{active: boolShowTechnosBandes}">
                  <table class="tab_technos">
                    <thead>
                      <tr class="trBande">
                        <th></th>
                        <th></th>
                        <th v-for="(operateur, index) in operateurData" :key="index" ><img :src="`/static/img/operateurs/logos/logo-${operateur.id}.png`" :alt="operateur.nom" :title="operateur.nom"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(operateurTechnoBande, index) in listeOperateurTechnoBande" :key="index" class="trTechno" :class="{technoPair: index % 2 == 0}">
                          <td v-if="operateurTechnoBande.technologie === '5G' && ((listeOperateurTechnoBande[index-1] != null && listeOperateurTechnoBande[index-1].technologie !== '5G') || index === 0)" :rowspan="nb5G" class="tdTechnoBande" :class="{bandePair: getParityTechno('5G') === true}"> {{operateurTechnoBande.technologie}}</td>
                          <td v-else-if="operateurTechnoBande.technologie === '4G' && ((listeOperateurTechnoBande[index-1] != null && listeOperateurTechnoBande[index-1].technologie !== '4G') || index === 0)" :rowspan="nb4G" class="tdTechnoBande" :class="{bandePair: getParityTechno('4G') === true}">{{operateurTechnoBande.technologie}}</td>
                          <td v-else-if="operateurTechnoBande.technologie === '3G' && ((listeOperateurTechnoBande[index-1] != null && listeOperateurTechnoBande[index-1].technologie !== '3G') || index === 0)" :rowspan="nb3G" class="tdTechnoBande" :class="{bandePair: getParityTechno('3G') === true}">{{operateurTechnoBande.technologie}}</td>
                          <td v-else-if="operateurTechnoBande.technologie === '2G' && ((listeOperateurTechnoBande[index-1] != null && listeOperateurTechnoBande[index-1].technologie !== '2G') || index === 0)" :rowspan="nb2G" class="tdTechnoBande" :class="{bandePair: getParityTechno('2G') === true}">{{operateurTechnoBande.technologie}}</td>
                          <td class="tdBande">{{operateurTechnoBande.bande}}</td>
                          <td v-for="(operateur, index) in operateurData" :key="index" class="tdCount" :style="{'background-color': addAlpha(operateur.code_couleur, 0.1), 'color' : operateur.code_couleur}">
                            <div v-if="findDataOperateur(operateurTechnoBande.operateurCount,operateur)">
                              <span class="countOperateurTechno">{{ findDataOperateur(operateurTechnoBande.operateurCount,operateur).count }}</span> {{' | ' + findDataOperateur(operateurTechnoBande.operateurCount,operateur).countService}}
                            </div>
                            <div v-else> {{'-'}} </div>
                          </td>
                        </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="technoVide" v-if="(boolShowTechnos || boolShowTechnosBandes) && (technologies.length === 0 || operateurs.length === 0)">
                {{ $t("message['Aucune donnée à afficher']") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="top_right">
      <div class="right_content" id="right-content">

        <!-- Bouton d'ouverture de la sidebar -->
        <div class="sidebar_button" :class="{ active: !$store.state.sidebar.active}">
          <button class="gears_btn" @click="toggleSidebar"><span>{{ $t("message['Configurer l affichage']") }}</span></button>
        </div>

        <!-- Tools / Outils -->
        <div class="tools">
          <button class="print" @click="print"></button>
          <button class="download" @click="exportCarte" v-if="$store.state.user.login"></button>
          <button class="save_maps save" id="btn_save_maps" @click="open('save_maps')" v-if="$store.state.user.login"></button>
          <div class="control-holder control-holder-fullscreen"></div>

          <button class="geolocation" :style="{ backgroundColor: this.position ? '' : 'gray' }" @click="centerOnLocation" :title="$t('message[\'Afficher votre position\']')"></button>
          <button class="measure" :class="{ active: this.measuringToolActive}" @click="toggleDistance"></button>
          <div class="zoom">
            <button class="zoom_plus" @click="zoomPlus"></button>
            <button class="zoom_less" @click="zoomMinus"></button>
          </div>
        </div>

        <!-- SIDEBAR -->
        <div class="sidebar" :class="{ active: $store.state.sidebar.active}">
          <div class="header" @click="toggleSidebar">
            <button class="close_sidebar"></button>
            <div class="sidebar_title">{{ $t("message['Outils et Réglages']") }}</div>
          </div>
          <div class="sidebar_content">

            <!-- FILTRER PAR COMMUNE -->
            <div class="filter_block">
              <!-- Styled checkbox -->
              <div class="switch_checkbox">
                <input type="checkbox" class="switch filter_par_commune" v-model="$store.state.localisation.active" name="filter_par_commune" id="filter_par_commune">
                <label for="filter_par_commune"></label>
              </div>
              <div>
                <p>{{ $t("message['Afficher uniquement les sites et les mesures de la commune de']") }} :</p>
                <search-commune :class="{ disabled: !$store.state.localisation.active, commune_search_bar: true }" @lonlat="lonlat" @changeLocalisation="reloadStats"></search-commune>
                <div class="stats">
                  <div :class="{stats_button_disabled:(!$store.state.localisation.active || this.$store.state.localisation.filter == null), stats_button:($store.state.localisation.active && this.$store.state.localisation.filter != null)}"  @click="showStats">
                    <img class="img-graph" src="../assets/img/graph.svg">
                    {{$t('message[\'Consulter les statistiques\']')}}
                  </div>
                </div>
              </div>
            </div>
            <!--Liste des territoires-->
            <div class="title_territoire">
              <img src="../assets/img/icon-geo.svg" alt="icone geolocalisation"/>
              {{ $t("message['Changer de zone géographique']") }}
            </div>
            <div class="dropdown" ref="dropdown">
                <div class="dropdown-toggle" @click="toggleDropdown">
                  <img :src="`/static/img/territoires/${selectedTerritory.codeign}.svg`" class="dropdown-option-image whitesvg">
                  <span class="dropdown-option-label">{{ selectedTerritory.name }}</span>
                  <span class="dropdown-caret"></span>
                </div>
                <ul class="dropdown-menu" v-show="isDropdownOpen">
                  <li v-for="(territoire,index) in this.territoires.slice(0, territoires.length - 1)" :key="index" :class="{dropdownPair: index % 2 == 0}" @click="switchTerritory(territoire)">
                    <img :src="`/static/img/territoires/${territoire.codeign}.svg`" class="dropdown-option-image">
                    <span class="dropdown-option-label">{{ territoire.name }}</span>
                  </li>
                </ul>
            </div>

            <!-- ANTENNES -->
            <div class="sidebar_block antennes" :class="[isDropdownOpen ? 'active' : '', 'backdrop']">

              <!-- Titre -->
              <div class="sidebar_block_title" :class="{ active: $store.state.supports.show }">
                <div class="switch_checkbox">
                  <input type="checkbox" v-model="$store.state.supports.show" class="switch show_all_antenna" name="show_all_antenna" id="show_all_antenna">
                  <label for="show_all_antenna"></label>
                </div>
                <span><label for="show_all_antenna">{{ $t("message['Afficher les sites radioélectriques']") }}</label></span>
                <button class="accordeon" onclick="var pNode=this.parentNode;if(pNode.classList.contains('active')){pNode.classList.remove('active')}else{pNode.classList.add('active')}"></button>
              </div>

              <div class="sidebar_block_details">
                <!-- Paramètres opérateurs -->
                <div class="parameters parameters_antenna active">
                  <!-- Filtre directions antennes -->
                  <div class="directionsAntennes checkboxes">
                      <input type="checkbox" v-model="$store.state.supports.direction" id="direction_antennes" class="direction_antennes" />
                      <label for="direction_antennes">{{ $t("message['Afficher la direction des antennes']") }}</label>
                  </div>

                  <!-- Téléphonie mobile -->
                  <div class="parameter">
                    <div class="switch_checkbox">
                      <input type="checkbox" v-model="$store.state.supports.categories['TEL'].show" @change="onFilterChange" class="switch telephonie" name="telephonie" id="telephonie">
                      <label for="telephonie">{{ $t("message['Téléphonie mobile']") }}</label>
                    </div>
                  </div>
                  <div class="telephonie_parameters_detail active">
                    <div class="operateurs_block">
                      <p class="title">{{ $tc("message['Opérateur']", 2) }} :</p>
                      <!-- opérateurs -->
                      <div class="operateurs">
                        <table class="operateurs_table">
                          <tr class="op">
                            <td v-for="(operateur, index) in this.$store.state.supports.tm.operateurs" :key="index" :class="{reverse : index % 2 != 0}">
                              <div>
                                <img :src="`/static/img/operateurs/logos/logo-${operateur.id}.png`" :alt="'logo ' + operateur.nom" :title="operateur.nom">
                              </div>
                              <div :style="{background:operateur.code_couleur}" class="square">
                              </div>

                              <div class="checkboxes">
                                <input type="checkbox" v-model="operateur.show" @change="onFilterChange" for="op_bouygues" class="op_bouygues" />
                                <label for="op_bouygues"></label>
                              </div>
                            </td>
                          </tr>

                        </table>
                      </div>
                      <!-- réseaux mobiles -->
                      <div class="reseaux_mobiles">
                        <p class="title">{{ $tc("message['Technos']", 2) }} :</p>
                        <div class="checkboxes">
                          <input type="checkbox" v-model="$store.state.supports.tm.technologies['5G'].show" @change="onFilterChange" id="reseaux_5G" class="reseaux_5G" />
                          <label for="reseaux_5G"><span class="reseaux_5G"></span>5G</label>
                        </div>
                        <div class="checkboxes">
                          <input type="checkbox" v-model="$store.state.supports.tm.technologies['4G'].show" @change="onFilterChange" id="reseaux_4G" class="reseaux_4G" />
                          <label for="reseaux_4G"><span class="reseaux_4G"></span>4G</label>
                        </div>
                        <div class="checkboxes">
                          <input type="checkbox" v-model="$store.state.supports.tm.technologies['3G'].show" @change="onFilterChange" id="reseaux_3G" class="reseaux_3G" />
                          <label for="reseaux_3G"><span class="reseaux_3G"></span>3G</label>
                        </div>
                        <div class="checkboxes">
                          <input type="checkbox" v-model="$store.state.supports.tm.technologies['2G'].show" @change="onFilterChange" id="reseaux_2G" class="reseaux_2G" />
                          <label for="reseaux_2G"><span class="reseaux_2G"></span>2G</label>
                        </div>
                      </div>
                      <!-- stations -->
                      <div class="stations">
                        <p class="title">{{ $tc("message['Site']", 2) }} :</p>
                        <div class="stations_switch">
                          <label class="radio">
                              <span>{{ $t("message['Tous les sites']") }}</span>
                              <input type="radio" name="stations" value="false" v-model="$store.state.supports.tm.active"/>
                              <div class="radio_indicator"></div>
                          </label>
                          <label class="radio">{{ $tc("message['Sites en service']", 2) }}
                              <input type="radio" name="stations" value="true" v-model="$store.state.supports.tm.active"/>
                              <div class="radio_indicator"></div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- TV -->
                  <div class="parameter param_tv">
                    <div class="switch_checkbox">
                      <input type="checkbox" v-model="$store.state.supports.categories['TNT'].show" @change="onFilterChange" class="switch tv" name="tv" id="tv">
                      <label for="tv"></label>
                    </div>
                    <p>{{ $t("message['TV']") }}</p>
                  </div>

                  <!-- Radio FM -->
                  <div class="parameter param_radio_fm">
                    <div class="switch_checkbox">
                      <input type="checkbox" v-model="$store.state.supports.systemes['FM'].show" @change="onFilterChange" class="switch radio_fm" name="radio_fm" id="radio_fm">
                      <label for="radio_fm"></label>
                    </div>
                    <p>{{ $t("message['Radio FM']") }}</p>
                  </div>

                  <!-- Radio AM -->
                  <div class="parameter param_radio_am">
                    <div class="switch_checkbox">
                      <input type="checkbox" v-model="$store.state.supports.systemes['AM'].show" @change="onFilterChange" class="switch radio_am" name="radio_am" id="radio_am">
                      <label for="radio_am"></label>
                    </div>
                    <p>{{ $t("message['Radio AM']") }}</p>
                  </div>

                  <!-- Radio RNT -->
                  <div class="parameter param_radio_rnt">
                    <div class="switch_checkbox">
                      <input type="checkbox" v-model="$store.state.supports.systemes['RNT'].show" @change="onFilterChange" class="switch radio_rnt" name="radio_rnt" id="radio_rnt">
                      <label for="radio_rnt"></label>
                    </div>
                    <p>{{ $t("message['Radio RNT']") }}</p>
                  </div>

                  <!-- Réseaux mobiles privés -->
                  <div class="parameter param_private_mobile_networks">
                    <div class="switch_checkbox">
                      <input type="checkbox" v-model="$store.state.supports.categories['PMR'].show" @change="onFilterChange" class="switch private_mobile_networks" name="private_mobile_networks" id="private_mobile_networks">
                      <label for="private_mobile_networks"></label>
                    </div>
                    <p>{{ $tc("message['Réseaux mobiles privés']", 2) }}</p>
                  </div>

                  <!-- Faisceaux hertziens -->
                  <div class="parameter param_hertzian_beam">
                    <div class="switch_checkbox">
                      <input type="checkbox" v-model="$store.state.supports.categories['FH'].show" @change="onFilterChange" class="switch hertzian_beam" name="hertzian_beam" id="hertzian_beam">
                      <label for="hertzian_beam"></label>
                    </div>
                    <p>{{ $tc("message['Faisceaux hertziens']", 2) }}</p>
                  </div>

                  <!-- Autres stations -->
                  <div class="parameter param_stations">
                    <div class="switch_checkbox">
                      <input type="checkbox" v-model="$store.state.supports.categories['AUTRES'].show" @change="onFilterChange" class="switch others_stations" name="others_stations" id="others_stations">
                      <label for="others_stations"></label>
                    </div>
                    <p>{{ $tc("message['Autre station']", 2) }}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- MESURES -->
            <div class="sidebar_block mesures" :class="[isDropdownOpen ? 'active' : '', 'backdrop']">

              <!-- Titre -->
              <div class="sidebar_block_title" :class="{ active: $store.state.mesures.show }">
                <div class="switch_checkbox">
                  <input type="checkbox" v-model="$store.state.mesures.show" class="switch show_all_measures" name="show_all_measures" id="show_all_measures">
                  <label for="show_all_measures"></label>
                </div>
                <span><label for="show_all_measures">{{ $t("message['Afficher les mesures']") }}</label></span>
                <button class="accordeon" onclick="var pNode=this.parentNode;if(pNode.classList.contains('active')){pNode.classList.remove('active')}else{pNode.classList.add('active')}"></button>
              </div>

              <div class="sidebar_block_details">
                <!-- Paramètres mesures -->

                <div class="parameters parameters_mesures active">
                  <!-- Stations radioélectriques-->
                  <div class="parameter param_mesures_stations">
                    <div class="switch_checkbox">
                      <input type="checkbox" v-model="$store.state.mesures.stations.show" class="switch show_all_measures_stations" name="show_all_measures_stations" id="show_all_measures_stations">
                      <label for="show_all_measures_stations"></label>
                    </div>
                    <p>{{ $tc("message['Stations radioélectriques (TV, radio FM, téléphonie mobile, DECT, WI-Fi...)']") }}</p>
                  </div>
                  <!-- Objets communicants-->
                  <div class="parameter param_mesures_objets">
                    <div class="switch_checkbox">
                      <input type="checkbox" v-model="$store.state.mesures.objets.show" class="switch show_all_measures_objets" name="show_all_measures_objets" id="show_all_measures_objets">
                      <label for="show_all_measures_objets"></label>
                    </div>
                    <p>{{ $tc("message['Objets communicants fixes']", 2) }}</p>
                  </div>
                  <!-- Ancienneté -->
                  <div class="parameter age">
                    <label>{{ $t("message['Ancienneté']") }} : </label>
                    <vue-slider ref="sliderMesuresAnciennete" v-bind="sliderMesuresAnciennete" v-model="$store.state.mesures.anciennete" ></vue-slider>
                  </div>

                  <!-- Niveaux -->
                  <div class="parameter sonde">
                    <label>{{ $t("message['Niveau mesuré']") }} : </label>
                    <vue-slider ref="sliderMesuresNiveaux" v-bind="sliderMesuresNiveaux" v-model="$store.state.mesures.niveaux"></vue-slider>
                    <div style="text-align:center;width:90%">
                      <span id="niveauSondeMesureLabel" class="cr-legend-choix">
                                            <span class="cr-label">{{ $t("message['Entre']") }} {{$store.state.mesures.niveaux[0]}} {{ $t("message['et']") }} {{$store.state.mesures.niveaux[1]}} V/m</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- SIMULATIONS -->
            <div v-if="isPNSEActif" class="sidebar_block simulations" :class="[isDropdownOpen ? 'active' : '', 'backdrop']">

              <!-- Titre -->
              <div class="sidebar_block_title" :class="{ active: $store.state.simulations.show && this.isPNSEActif }">
                <div class="switch_checkbox">
                  <input
                    type="checkbox"
                    class="switch show_all_simulations"
                    name="show_all_simulations"
                    id="show_all_simulations"
                    :checked="$store.state.simulations.show"
                    @click="onSimulationsChange"
                  >
                  <label for="show_all_simulations"></label>
                </div>
                <span><label for="show_all_simulations">{{ $t("message['Afficher les simulations']") }}</label></span>
                <button class="accordeon" onclick="var pNode=this.parentNode;if(pNode.classList.contains('active')){pNode.classList.remove('active')}else{pNode.classList.add('active')}"></button>
              </div>
              <div class="sidebar_block_details">
                <div class="parameter param_osm">
                  <div class="switch_checkbox">
                    <input
                      type="checkbox"
                      class="switch osm"
                      id="osm"
                      :checked="$store.state.simulations.showBackground"
                      :disabled="!$store.state.simulations.show || !isPNSEActif"
                      @change="clickOSM">
                    <label for="osm"></label>
                  </div>
                  <p>Masquer les calques</p>
                </div>
                <!-- Paramètres simulations -->
                <div class="parameters parameters_simulations active">
                  <div class="param_simulations">
                    <!-- Sol-->
                    <div class="param_simulations" v-if="isPNSESolVisible">
                      <div class="switch_checkbox">
                        <input type="checkbox" v-model="$store.state.simulations.sol.show" class="switch show_all_simulations_sol" name="show_all_simulations_sol" id="show_all_simulations_sol">
                        <label for="show_all_simulations_sol"></label>
                      </div>
                      <p>{{ $t("message['Afficher le sol']") }}</p>
                    </div>
                    <!-- Façade-->
                    <div class="param_simulations" v-if="isPNSEFacadeVisible">
                      <div class="switch_checkbox">
                        <input type="checkbox" v-model="$store.state.simulations.facade.show" class="switch show_all_simulations_facade" name="show_all_simulations_facade" id="show_all_simulations_facade">
                        <label for="show_all_simulations_facade"></label>
                      </div>
                      <p>{{ $t("message['Afficher la facade']") }}</p>
                    </div>
                  </div>
                  <!-- Légende -->
                  <div style="text-align:center">
                    <img src="../assets/img/simulations_legende.png"/>
                  </div>
                  <div class="modal_text" v-html="messageLimiteReglementaire"></div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div id="save_maps" class="tools_modal">
          <!-- Modal content -->
          <div class="tools_modal_content">
            <button class="tools_modal_close" @click="close('save_maps')"></button>
            <div class="tools_modal_header">
              {{ $t("message['Enregistrement de la carte active']") }}
            </div>
            <div class="modal-dialog-content savemap-dialog-content">
              <span class="cr-label">{{ $t("message['Nom de la carte']") }} :</span>
              <input v-model="savedMap" style="width: 60%; height: 25px;" type="text" :placeholder="$t('message[\'Nom de la carte\']')"><br>
              <span class="error_save" v-if="errorSave">{{ $t("message['Veuillez renseigner le nom de la carte']") }}.</span>
            </div>
            <div class="tools_modal_footer">
              <div class="modal-dialog-buttons">
                <button name="close" class="fermer" @click="close('save_maps')">{{ $t("message['Fermer']") }}</button>
                <button name="save" class="enregistrer" @click="saveMap">{{ $t("message['Enregistrer']") }}</button>
              </div>
            </div>
          </div>
        </div>
        <div id="download_map" class="tools_modal">
          <!-- Modal content -->
          <div class="tools_modal_content">
            <button class="tools_modal_close" @click="close('download_map')"></button>
            <div class="tools_modal_header">
              {{ $t("message['Exporter les données']") }}
            </div>
            <div class=" modal-dialog-content downloadmap-dialog-content">
              <span class="cr-label">{{ $t("message['Emprise']") }} :</span>
              <select @change="changeExport" class="selectExport" v-model="selectedExport">
                  <option disabled value="null"></option>
                  <option v-for="(type, index) in typeExportLocalisation()" :key="index" v-bind:value="type.type">
                    <div v-if="type.type === 'emprise'" > {{type.libelle}} </div>
                    <div v-else-if="type.type === 'departement'">{{type.libelle + ' ' + $t("message['selectionne']")}}</div>
                    <div v-else-if="type.type === 'fauxdepartement'">{{localisationInfo.label + ' ' + $t("message['selectionnee']")}}</div>
                    <div v-else>{{type.libelle + ' ' + $t("message['selectionnee']")}}</div>
                  </option>
              </select>
              <span class="error_save" v-if="selectedExport === null && errorDownload"><br>{{ $t("message['Veuillez renseigner un type d emprise']") }}.</span>
            </div>
            <div class="tools_modal_footer">
              <div class="modal-dialog-buttons">
                <button name="close" class="fermer" @click="close('download_map')">{{ $t("message['Fermer']") }}</button>
                <button name="save" class="enregistrer" @click="downloadMap(selectedExport)">{{ $t("message['Exporter']") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
// Vue.js
/* eslint-disable no-new */

// https://lodash.com/
import _ from 'lodash'

// https://github.com/marcuswestin/store.js/
import storeJs from 'store'

// https://github.com/NightCatSama/vue-slider-component
import VueSlider from 'vue-slider-component'

import axios from 'axios'

// https://www.npmjs.com/package/browser-detect
import browser from 'browser-detect'

// https://www.npmjs.com/package/swipe-listener
import swipeListener from 'swipe-listener'

// https://openlayers.org/en/latest/apidoc/
import 'ol/ol.css'
import OlMap from 'ol/map'
import OlEasing from 'ol/easing'
import OlInteraction from 'ol/interaction'
import OlInteractionSelect from 'ol/interaction/select'
import OlControl from 'ol/control'
import OlView from 'ol/view'
import OlLayerTile from 'ol/layer/tile'
import OlProj from 'ol/proj'
import OlExtent from 'ol/extent'
import OlTilegridWMTS from 'ol/tilegrid/wmts'
import OlSourceWMTS from 'ol/source/wmts'
import OlSourceVector from 'ol/source/vector'
import OlSourceCluster from 'ol/source/cluster'
import OlFormatGeoJSON from 'ol/format/geojson'
import OlSourceOSM from 'ol/source/osm'
import OlLayerVector from 'ol/layer/vector'
import OlLoadingstrategy from 'ol/loadingstrategy'
import OlStyleStyle from 'ol/style/style'
import OlStyleFill from 'ol/style/fill'
import OlStyleText from 'ol/style/text'
import OlStyleIcon from 'ol/style/icon'
import OlLayerGroup from 'ol/layer/group'
import OlLayerImage from 'ol/layer/image'
import OlSourceImageWMS from 'ol/source/imagewms'
import OlControlScaleLine from 'ol/control/scaleline'
import OlControlFullScreen from 'ol/control/fullscreen'
import OlInteractionDraw from 'ol/interaction/draw'
import OlOverlay from 'ol/overlay'
import OlGeolocation from 'ol/geolocation'
import OlSphere from 'ol/sphere.js'
import OlFeatureloader from 'ol/featureloader'

import EventBus from '../bus'
import * as eventTypes from '../bus/event-types.js'

import SearchAdresse from './SearchAdresse.vue'
import SearchCommune from './SearchCommune.vue'

import FicheSupport from './FicheSupport'
import FicheMesure from './FicheMesure'

import MapExporter from './print/MapExporter'
import MapPrinter from './print/MapPrinter'

import FileExporter from './print/FileExporter'

export default {
  name: 'OlMap',
  components: {
    SearchAdresse,
    SearchCommune,
    VueSlider,
    FicheSupport,
    FicheMesure
  },

  i18n: {
    messages: {
      en: {
        message: {
          'Veuillez zoomer': 'Please zoom',
          'Veuillez zoomer pour visualiser les': 'Please zoom in to view the',
          'Afficher uniquement les sites et les mesures de la commune de': 'Display only supports and measurements of the municipality of',
          'Afficher les sites radioélectriques': 'Display antennas',
          'Outils et Réglages': 'Tools and Settings',
          'Afficher la direction des antennes': 'Show antennas\'s direction',
          'Exporter les données': 'Export data',
          'Emprise': 'Extent',
          'Commune': 'Municipality',
          'Département': 'Department',
          'Région': 'Region',
          'FauxDépartement': 'Lyon/Marseille',
          'Emprise de la carte actuelle': 'Extent of the current map',
          'Exporter': 'Export',
          'Veuillez renseigner le nom de la commune': 'Please enter the name of the municipality',
          'Veuillez renseigner le nom du département': 'Please enter the name of the department',
          'Veuillez renseigner un type d emprise': 'Please enter a type of Extent',
          'Votre demande a été prise en compte. Le lien de téléchargement des données demandées va vous être communiqué par messagerie dans quelques minutes.': 'Your request has been registered. The download link for the requested data will be communicated to you by email in a few minutes.',
          'L emprise de la carte est trop importante. Merci de zoomer.': 'The card\'s extent is too important. Please zoom in.',
          'Entrez une adresse pour trouver un lieu. J ai compris, ne plus voir cette information.': 'Enter an address in order to find a place.<br/><u>I\'ve understood, don\'t show this anymore.</u>',
          'Une erreur est survenue lors de la demande d export des donnees': 'An error occurred while requesting to export data',
          'Texte absent': 'Missing text',
          'selectionnee': 'selected',
          'selectionne': 'selected',
          'Consulter les statistiques': 'Show statistics',
          'Comptage des sites radioélectriques': 'Counting of radio sites',
          'Total des sites': 'Total sites',
          'Le total des sites ci-dessus': 'The total of the sites above takes into account the mutualizations. Depending on the level of detail of the selected criteria, it may be less than the sum of the sites counted on the right of the screen.',
          'Téléphonie mobile': 'Mobile telephony',
          'Détails': 'Details',
          'Accéder au détail': 'Access to details',
          'TV': 'TV',
          'Radio FM': 'FM Radio',
          'Radio AM': 'AM Radio',
          'Radio RNT': 'Digital Radio',
          'Réseaux mobile privés': 'Private mobile networks',
          'Faisceaux Hertziens': 'Hertzian beam',
          'Autres stations': 'Other stations',
          'sites': 'sites',
          'dont': 'with',
          'en service': 'in service',
          'Retour': 'Back',
          'Détail par opérateur': 'Details by operator',
          'Technologies': 'Technologies',
          'Technologies + Bandes de fréquences': 'Technologies + Frequency bands',
          'Tous les sites | Sites en service': 'All sites | Sites in service',
          'Aucune donnée à afficher': 'No data to display',
          'Afficher votre position': 'show your location'
        }
      },
      fr: {
        message: {
          'Veuillez zoomer': 'Veuillez zoomer',
          'Veuillez zoomer pour visualiser les': 'Veuillez zoomer pour visualiser les',
          'Afficher uniquement les sites et les mesures de la commune de': 'Afficher uniquement les sites et les mesures de la commune, du département ou de la région de',
          'Afficher les sites radioélectriques': 'Afficher les sites radioélectriques',
          'Outils et Réglages': 'Outils et Réglages',
          'Afficher la direction des antennes': 'Afficher la direction des antennes',
          'Exporter': 'Exporter',
          'Exporter les données': 'Exporter les données',
          'Emprise': 'Emprise',
          'Commune': 'Commune',
          'Département': 'Département',
          'Région': 'Région',
          'FauxDépartement': 'Lyon/Marseille',
          'Emprise de la carte actuelle': 'Emprise de la carte actuelle',
          'Veuillez renseigner le nom de la commune': 'Veuillez renseigner le nom de la commune',
          'Veuillez renseigner le nom du département': 'Veuillez renseigner le nom du département',
          'Veuillez renseigner un type d emprise': 'Veuillez renseigner un type d\'emprise',
          'Votre demande a été prise en compte. Le lien de téléchargement des données demandées va vous être communiqué par messagerie dans quelques minutes.': 'Votre demande a été prise en compte. Le lien de téléchargement des données demandées va vous être communiqué par messagerie dans quelques minutes.',
          'L emprise de la carte est trop importante. Merci de zoomer.': 'L\'emprise de la carte est trop importante. Merci de zoomer.',
          'Entrez une adresse pour trouver un lieu. J ai compris, ne plus voir cette information.': 'Entrez une adresse pour trouver un lieu.<br/><u>J\'ai compris, ne plus voir cette information.</u>',
          'J ai compris, ne plus voir cette information.': 'J\'ai compris, ne plus voir cette information.',
          'Texte absent': 'Texte absent',
          'Une erreur est survenue lors de la demande d export des donnees': 'Une erreur est survenue lors de la demande d\'export des données',
          'selectionnee': 'sélectionnée',
          'selectionne': 'sélectionné',
          'Consulter les statistiques': 'Consulter les statistiques',
          'Comptage des sites radioélectriques': 'Comptage des sites radioélectriques',
          'Total des sites': 'Total des sites',
          'Le total des sites ci-dessus': 'Le total des sites ci-dessus prend en compte les mutualisations. Selon le niveau de détail des critères selectionnés, il peut donc être inférieur à la somme des sites comptés à droite de l\'écran.',
          'Téléphonie mobile': 'Téléphonie mobile',
          'Détails': 'Détails',
          'Accéder au détail': 'Accéder au détail',
          'TV': 'TV',
          'Radio FM': 'Radio FM',
          'Radio AM': 'Radio AM',
          'Radio RNT': 'Radio RNT',
          'Réseaux mobile privés': 'Réseaux mobiles privés',
          'Faisceaux Hertziens': 'Faisceaux Hertziens',
          'Autres stations': 'Autres stations',
          'sites': 'sites',
          'dont': 'dont',
          'en service': 'en service',
          'Retour': 'Retour',
          'Détail par opérateur': 'Détail par opérateur',
          'Technologies': 'Technologies',
          'Technologies + Bandes de fréquences': 'Technologies + Bandes de fréquences',
          'Tous les sites | Sites en service': 'Tous les sites | Sites en service',
          'Aucune donnée à afficher': 'Aucune donnée à afficher',
          'Afficher votre position': 'Afficher votre position'
        }
      }
    }
  },

  props: {
    lat: {
      required: false,
      type: Number
    },
    lon: {
      required: false,
      type: Number
    },
    zoom: {
      required: false,
      type: Number,
      default: 10
    },
    mapid: {
      required: false,
      type: Number
    }
  },

  data() {
    return {
      showPopup: false,
      CR_EXPLOITANTS_TM: {
        PMT_VODAFONE: 267,
        GLOBALTEL: 266,
        BOUYGUES_TELECOM: 6,
        OUTREMER_TELECOM: 147,
        SPM_TELECOM: 148,
        SFR: 137,
        ZEOP: 285,
        VITI_SAS: 246,
        MAORE_MOBILE: 252,
        SRR: 193,
        ORANGE: 23,
        DAUPHIN_TELECOM: 153,
        ONATI: 227,
        BPT: 228,
        DIGICEL: 162,
        TELCO_OI: 278,
        Gouv_Nelle_Calédonie_OPT: 166,
        UTS_Caraibes: 157,
        FREE_MOBILE: 240,
        FREE_CARAIBES: 307,
        AUTRE: -1
      },
      typeExport: [{
        type: 'emprise',
        libelle: this.$t("message['Emprise de la carte actuelle']"),
        code: 'EMP'
      }, {
        type: 'departement',
        libelle: this.$t("message['Département']"),
        code: 'DEP'
      },
      {
        type: 'fauxdepartement',
        libelle: this.$t("message['FauxDépartement']"),
        code: 'FDEP'
      },
      {
        type: 'commune',
        libelle: this.$t("message['Commune']"),
        code: 'COM'
      },
      {
        type: 'region',
        libelle: this.$t("message['Région']"),
        code: 'REG'
      }],
      selectedExport: null,
      map: {
        type: Object,
        default: {}
      },
      geolocation: null,
      position: null,
      marker: null,
      lonlatMarker: null,
      savedMap: '',
      errorSave: false,
      errorDownload: false,
      resolution: null,
      supportsMaxDensityReached: false,
      mesuresMaxDensityReached: false,
      currentZoom: 10,
      styleCache: {},
      // Conserver une consistance dans l'affichage des supports (que des compteurs ou que des symboles)
      supportsConsistent: false,
      measuringTool: {},
      measuringToolActive: false,

      sliderMesuresAnciennete: {
        lazy: true,
        clickable: false,
        width: '70%',
        tooltip: 'always',
        tooltipDir: 'top',
        disabled: false,
        piecewise: true,
        piecewiseLabel: true,
        style: {
          marginTop: '30px',
          marginBottom: '30px',
          marginLeft: '10%'
        },
        data: [
          31,
          182,
          365,
          720,
          20000
        ],
        formatter: (v) => {
          return this.$t("message['" + v + "-days-anciennete']")
        },
        bgStyle: {
          height: '3px',
          top: '3px'
        },
        piecewiseStyle: {
          backgroundColor: '#ccc',
          visibility: 'visible',
          width: '10px',
          height: '10px'
        },
        piecewiseActiveStyle: {
          backgroundColor: '#cc3399'
        }
        // , labelActiveStyle: { color: '#cc3399' }
      },

      sliderMesuresNiveaux: {
        lazy: true,
        clickable: false,
        width: '70%',
        tooltip: 'always',
        tooltipDir: 'top',
        disabled: false,
        formatter: '{value} V/m',
        style: {
          marginTop: '30px',
          marginBottom: '5px',
          marginLeft: '10%'
        },
        dotWidth: 7,
        dotHeight: 16,
        min: 0,
        max: 87,
        bgStyle: {
          height: '3px',
          top: '3px'
        }
      },
      // On zoome sur la prochaine position connue
      nextPositionZoomOn: false,

      // Savoir si on affiche les informations sur la directions de l'antenne la plus proche

      displayFicheAntenne: true,

      // Statistiques
      boolShowStats: false,
      boolShowDetail: false,
      boolShowTechnos: false,
      boolShowTechnosBandes: false,
      totalSites: 0,
      nbTel: 0,
      nbTv: 0,
      nbRadio: 0,
      nbRmp: 0,
      nbFh: 0,
      nbAutres: 0,
      nbTelService: 0,
      nbOrange: 0,
      nbOrangeService: 0,
      nbSfr: 0,
      nbSfrService: 0,
      nbBouygues: 0,
      nbBouyguesService: 0,
      nbFree: 0,
      nbFreeService: 0,
      listeOperateurTechno: [],
      listeOperateurTechnoBande: null,
      nb5G: 0,
      nb4G: 0,
      nb3G: 0,
      nb2G: 0,
      technoSorted: [],
      operateurData: [],
      operateurServiceData: null,
      X: null,
      operateursAutre: true,

      // territoires
      isDropdownOpen: false,
      dropdown: null,
      selectedTerritory: this.$store.state.territoires[0],
      isTerritoire: false,
      isFrance: false,

      // valeur du zoom minimum où le layer sol/façade est visible
      ZOOM_MINIMUM_COEXYA: 13
    }
  },
  computed: {
    messageLimiteReglementaire() {
      return this.$t("message['Valeurs limites réglementaires pour la téléphonie mobile']")
    },
    urlFAQ() {
      return this.$store.state.paramUrl.URL_FAQ ? this.$store.state.paramUrl.URL_FAQ : ''
    },
    notifPNSE() {
      return this.$store.state.paramUrl.NOTIF_PNSE ? this.$store.state.paramUrl.NOTIF_PNSE.replace('{{link}}', this.urlFAQ)
        : this.$t("message['Texte absent']")
    },
    id() {
      return this.$options.name + '-' + this._uid
    },
    ignKey() {
      return this.$store.state.params.ignKey
    },
    ign() {
      return this.$store.state.ign
    },
    layerFacade() {
      return this.$store.state.paramUrl.LAYER_FACADE ? this.$store.state.paramUrl.LAYER_FACADE : ''
    },
    layerHorizontal() {
      return this.$store.state.paramUrl.LAYER_HORIZONTAL ? this.$store.state.paramUrl.LAYER_HORIZONTAL : ''
    },
    layerOrtho() {
      return this.$store.state.paramUrl.LAYER_ORTHO ? this.$store.state.paramUrl.LAYER_ORTHO : ''
    },
    layerGeo() {
      return this.$store.state.paramUrl.LAYER_GEO ? this.$store.state.paramUrl.LAYER_GEO : ''
    },
    layerOpenStreet() {
      return this.$store.state.paramUrl.LAYER_OPENSTREET ? this.$store.state.paramUrl.LAYER_OPENSTREET : ''
    },
    urlGeoplateforme() {
      return this.$store.state.paramUrl.URL_GEOPLATEFORME ? this.$store.state.paramUrl.URL_GEOPLATEFORME : ''
    },
    urlCoexya() {
      return this.$store.state.paramUrl.URL_COEXYA ? this.$store.state.paramUrl.URL_COEXYA : ''
    },
    isPNSEActif() {
      return this.$store.state.paramUrl.PNSE_ACTIF ? this.$store.state.paramUrl.PNSE_ACTIF === 'true' : false
    },
    isPNSESolActif() {
      return this.$store.state.paramUrl.PNSE_SOL_ACTIF ? this.$store.state.paramUrl.PNSE_SOL_ACTIF === 'true' : false
    },
    isPNSEFacadeActif() {
      return this.$store.state.paramUrl.PNSE_FACADE_ACTIF ? this.$store.state.paramUrl.PNSE_FACADE_ACTIF === 'true' : this.isPNSEFacadeVisible
    },
    isPNSESolVisible() {
      return this.$store.state.paramUrl.PNSE_SOL_VISIBLE ? this.$store.state.paramUrl.PNSE_SOL_VISIBLE === 'true' : false
    },
    isPNSEFacadeVisible() {
      return this.$store.state.paramUrl.PNSE_FACADE_VISIBLE ? this.$store.state.paramUrl.PNSE_FACADE_VISIBLE === 'true' : false
    },
    footerHeightChange() {
      return this.$store.state.footer.active
    },
    directionVisible() {
      return this.$store.state.supports.show && this.$store.state.supports.tm.show && this.$store.state.supports.tm.direction
    },
    directionTMVisible() {
      return this.$store.state.supports.show && this.$store.state.supports.tm.show && this.$store.state.supports.direction
    },
    operateurVisible() {
      return this.$store.state.supports.categories['TEL'].show && this.$store.state.supports.show && this.$store.state.supports.microwavetransmission.show && this.$store.state.supports.direction
    },
    localisationId() {
      return this.$store.state.localisation.active && this.$store.state.localisation.filter ? this.$store.state.localisation.filter.id : null
    },
    localisationInfo() {
      return this.$store.state.localisation.active && this.$store.state.localisation.filter ? this.$store.state.localisation.filter : null
    },
    localisationVisible() {
      return this.$store.state.localisation.active && this.$store.state.localisation.filter != null
    },
    supportsVisible() {
      return this.$store.state.supports.show
    },
    territoires() {
      return this.$store.state.territoires
    },
    supportsUrlType() {
      let supports = []
      Object.entries(this.$store.state.supports.categories).forEach(([key, value]) => {
        if (value.show) {
          supports.push(key)
        }
      })
      return supports
    },
    systemeUrlType() {
      let supports = []
      Object.entries(this.$store.state.supports.systemes).forEach(([key, value]) => {
        if (value.show) {
          supports.push(key)
        }
      })
      return supports
    },
    technologies() {
      let technologies = []
      Object.entries(this.$store.state.supports.tm.technologies).forEach(([key, value]) => {
        if (value.show) {
          technologies.push(key)
        }
      })
      return technologies
    },
    technologiesnot() {
      let technologies = []
      Object.entries(this.$store.state.supports.tm.technologies).forEach(([key, value]) => {
        if (!value.show) {
          technologies.push(key)
        }
      })
      return technologies
    },
    operateurs() {
      let operateurs = []
      this.$store.state.supports.tm.operateurs.forEach((value) => {
        if (value.id !== -1) {
          if (value.show) {
            operateurs.push(value.id)
          }
        }
      })
      return operateurs
    },
    operateursnot() {
      let operateurs = []
      this.$store.state.supports.tm.operateurs.forEach((value) => {
        if (value.id !== -1) {
          if (!value.show) {
            operateurs.push(value.id)
          }
        }
      })
      return operateurs
    },
    supportsUrlBase() {
      return '/api/v1/sites?' +
        'categories=' + this.supportsUrlType +
        '&technologies=' + this.technologies +
        '&operateurs=' + this.operateurs +
        '&operateursnot=' + this.operateursnot +
        '&operateurautre=' + this.operateursAutre +
        '&enservice=' + this.$store.state.supports.tm.active +
        '&systemes=' + this.systemeUrlType +
        (this.localisationInfo && this.localisationInfo.type === 'COM' && this.localisationId ? '&commune=' + this.localisationId : '') +
        (this.localisationInfo && this.localisationInfo.type === 'DEP' && this.localisationId ? '&departement=' + this.localisationId : '') +
        (this.localisationInfo && this.localisationInfo.type === 'REG' && this.localisationId ? '&region=' + this.localisationId : '') +
        (this.localisationInfo && this.localisationInfo.type === 'FDEP' && this.localisationId ? '&fauxdepartement=' + this.localisationId : '') +
        '&format=geojson'
    },
    directionParamsBase() {
      let viewparams = 'technologies:' + (this.technologies.length > 0 ? this.technologies.join('\\,') : 'null') + ';'
      viewparams += 'operateurs:' + (this.operateurs.length > 0 ? this.operateurs.join('\\,') : '0') + ';'
      viewparams += 'operateurautre:' + this.operateursAutre + ';'
      viewparams += 'tm:' + this.$store.state.supports.categories['TEL'].show + ';'
      viewparams += 'fh:' + this.$store.state.supports.categories.FH.show + ';'
      viewparams += 'idregion:' + (this.localisationInfo && this.localisationInfo.type === 'REG' ? this.localisationInfo.id : 0) + ';'
      viewparams += 'iddepartement:' + (this.localisationInfo && this.localisationInfo.type === 'DEP' ? this.localisationInfo.id : 0) + ';'
      viewparams += 'idfauxdepartement:' + (this.localisationInfo && this.localisationInfo.type === 'FDEP' ? this.localisationInfo.id : 0) + ';'
      viewparams += 'idcommune:' + (this.localisationInfo && this.localisationInfo.type === 'COM' ? this.localisationInfo.id : 0) + ';'
      viewparams += 'enservice:' + this.$store.state.supports.tm.active

      let params = {
        'LAYERS': 'direction',
        'VIEWPARAMS': viewparams
      }
      return params
    },

    communeParamsBase() {
      let viewparams = 'idcommune:' + (this.localisationInfo && this.localisationInfo.type === 'COM' ? this.localisationInfo.id : 0)
      let params = {
        'LAYERS': 'commune',
        'VIEWPARAMS': viewparams
      }
      return params
    },

    departementParamsBase() {
      let viewparams = 'iddepartement:' + (this.localisationInfo && this.localisationInfo.type === 'DEP' ? this.localisationInfo.id : 0)
      let params = {
        'LAYERS': 'departement',
        'VIEWPARAMS': viewparams
      }
      return params
    },

    fauxDepartementParamsBase() {
      let viewparams = 'idfauxdepartement:' + (this.localisationInfo && this.localisationInfo.type === 'FDEP' ? this.localisationInfo.id : 0)
      let params = {
        'LAYERS': 'fauxdepartement',
        'VIEWPARAMS': viewparams
      }
      return params
    },

    regionParamsBase() {
      let viewparams = 'idregion:' + (this.localisationInfo && this.localisationInfo.type === 'REG' ? this.localisationInfo.id : 0)
      let params = {
        'LAYERS': 'region',
        'VIEWPARAMS': viewparams
      }
      return params
    },

    operateurParamsBase() {
      let viewparams = 'technologies:' + (this.technologies.length > 0 ? this.technologies.join('\\,') : 'null') + ';'
      viewparams += 'operateurs:' + (this.operateurs.length > 0 ? this.operateurs.join('\\,') : '0') + ';'
      viewparams += 'operateurautre:' + this.operateursAutre + ';'
      viewparams += 'idregion:' + (this.localisationInfo && this.localisationInfo.type === 'REG' ? this.localisationInfo.id : 0) + ';'
      viewparams += 'iddepartement:' + (this.localisationInfo && this.localisationInfo.type === 'DEP' ? this.localisationInfo.id : 0) + ';'
      viewparams += 'idfauxdepartement:' + (this.localisationInfo && this.localisationInfo.type === 'FDEP' ? this.localisationInfo.id : 0) + ';'
      viewparams += 'idcommune:' + (this.localisationInfo && this.localisationInfo.type === 'COM' ? this.localisationInfo.id : 0) + ';'
      viewparams += 'enservice:' + this.$store.state.supports.tm.active

      let params = {
        'LAYERS': 'operateur',
        'VIEWPARAMS': viewparams

      }
      return params
    },

    mesuresVisible() {
      return this.$store.state.mesures.show
    },
    simulationsVisible() {
      return this.$store.state.simulations.show && this.isPNSEActif
    },
    mesuresUrlBase() {
      return '/api/v1/mesures?' +
        (this.localisationInfo && this.localisationInfo.type === 'COM' && this.localisationId ? '&commune=' + this.localisationId : '') +
        (this.localisationInfo && this.localisationInfo.type === 'DEP' && this.localisationId ? '&departement=' + this.localisationId : '') +
        (this.localisationInfo && this.localisationInfo.type === 'FDEP' && this.localisationId ? '&fauxdepartement=' + this.localisationId : '') +
        (this.localisationInfo && this.localisationInfo.type === 'REG' && this.localisationId ? '&region=' + this.localisationId : '') +
        '&stationsRadioelec=' + this.$store.state.mesures.stations.show +
        '&objetsCom=' + this.$store.state.mesures.objets.show +
        '&anciennete=' + this.$store.state.mesures.anciennete +
        '&valeurLimiteMin=' + this.$store.state.mesures.niveaux[0] +
        '&valeurLimiteMax=' + this.$store.state.mesures.niveaux[1] +
        '&format=' + 'geojson'
    },

    simulationsSolUrlBase() {
      return this.$store.state.simulations.sol.show
    },

    simulationsFacadeUrlBase() {
      return this.$store.state.simulations.facade.show
    },

    showWarning() {
      return (this.supportsVisible && this.supportsMaxDensityReached) ||
        (this.mesuresVisible && this.mesuresMaxDensityReached) ||
        (this.simulationsVisible && this.currentZoom < this.ZOOM_MINIMUM_COEXYA)
    }
  },
  watch: {
    '$route': 'fetchMap',
    ign() {
      let orthoLayerIGN = this.findLayer(this.layerOrtho)
      let planLayerIGN = this.findLayer(this.layerGeo)
      let planLayerOSM = this.findLayer(this.layerOpenStreet)
      let currentIgnLayer = this.$store.state.ign
      orthoLayerIGN.setVisible(currentIgnLayer === orthoLayerIGN.get('layerName'))
      planLayerIGN.setVisible(currentIgnLayer === planLayerIGN.get('layerName'))
      planLayerOSM.setVisible(currentIgnLayer === planLayerOSM.get('layerName'))
    },
    footerHeightChange() {
      let effectDuration = 500
      let refreshTime = 25
      _.times(effectDuration / refreshTime, function(index) {
        setTimeout(function() {
          this.map.updateSize()
          this.handleResize()
        }.bind(this), (index + 1) * refreshTime + 10)
      }.bind(this), this)
    },
    directionTMVisible(newValue, oldValue) {
      this.findLayer('Direction').setVisible(newValue)
    },
    operateurVisible(newValue, oldValue) {
      this.findLayer('Operateur').setVisible(newValue)
    },
    localisationId() {
      this.refreshCommuneLayer()
    },
    localisationVisible(newValue, oldValue) {
      this.findLayer('Commune').setVisible(newValue)
      this.findLayer('Departement').setVisible(newValue)
      this.findLayer('FauxDepartement').setVisible(newValue)
      this.findLayer('Region').setVisible(newValue)
    },
    supportsVisible(newValue, oldValue) {
      this.findLayer('Supports').setVisible(newValue)
    },
    supportsUrlBase(newValue, oldValue) {
      this.refreshSupportsLayer()
    },
    directionParamsBase(newValue, oldValue) {
      this.refreshDirectionLayer()
    },
    operateurParamsBase(newValue, oldValue) {
      this.refreshOperateurLayer()
    },
    regionParamsBase(newValue, oldValue) {
      this.refreshRegionLayer()
    },
    departementParamsBase(newValue, oldValue) {
      this.refreshDepartementLayer()
    },
    fauxDepartementParamsBase(newValue, oldValue) {
      this.refreshFauxDepartementLayer()
    },
    communeParamsBase(newValue, oldValue) {
      this.refreshCommuneLayer()
    },
    mesuresUrlBase(newValue, oldValue) {
      this.refreshMesuresLayer()
    },
    simulationsSolUrlBase(newValue, oldValue) {
      this.refreshSimulationsSolLayer(newValue)
    },
    simulationsFacadeUrlBase(newValue, oldValue) {
      this.refreshSimulationsFacadeLayer(newValue)
    },
    mesuresVisible(newValue, oldValue) {
      this.findLayer('Mesures').setVisible(newValue)
    },
    simulationsVisible(newValue, oldValue) {
      this.refreshSimulationsFacadeLayer(newValue)
      this.refreshSimulationsSolLayer(newValue)
    },
    '$store.state.simulations.show': function() {
      let hideSearchHelpNotification = storeJs.get('cr:hide-info-pnse-notification')
      if (this.$store.state.simulations.show) {
        window._paq.push(['trackEvent', 'Cartoradio', 'Cartographie', 'Afficher les simulations d\'exposition'])
        if (!hideSearchHelpNotification) {
          const modal = document.getElementById('pnse-notification')
          modal.classList.add('active')
        }
      }
    }
  },

  mounted() {
    this.$store.state.menu.active = false
    this.$store.state.footer.active = false
    this.$store.state.sidebar.active = false
    this.$store.state.simulations.sol.show = this.isPNSESolActif && this.isPNSEActif
    this.$store.state.simulations.facade.show = this.isPNSEFacadeActif && this.isPNSEActif
    this.chargeOperateurs('FXX') // France métropolitaine

    // EventBus.$on(eventTypes.MAP_SETEXTENT, this.zoomtoExtent)
    // Ecoute des événements ouverture de fiches
    EventBus.$on(eventTypes.OPEN_SUPPORTS, hashes => {
      this.$refs['ficheMesure'].close()
      this.$refs['ficheSupport'].loadSupports(
        hashes,
        this.supportsUrlType,
        this.systemeUrlType,
        this.operateurs,
        this.operateursnot,
        this.operateursAutre,
        this.technologies
      )
      var ficheantenne = document.getElementById('ficheantennePopup')
      ficheantenne.style.display = 'none'
      this.displayFicheAntenne = false
    })
    EventBus.$on(eventTypes.OPEN_MESURES, hashes => {
      this.$refs['ficheSupport'].close()
      this.$refs['ficheMesure'].loadMesures(hashes)
      var ficheantenne = document.getElementById('ficheantennePopup')
      ficheantenne.style.display = 'none'
      this.displayFicheAntenne = false
    })

    this.map = new OlMap({
      loadTilesWhileAnimating: true,
      loadTilesWhileInteracting: true,
      controls: OlControl.defaults({
        rotate: false,
        zoom: false,
        attribution: false,
        attributionOptions: {
          collapsible: false
        }
      }).extend([
        new OlControlScaleLine({
          target: document.getElementById('scaleContainer')
        }),
        new OlControlFullScreen({
          tipLabel: 'Plein écran',
          target: document.getElementsByClassName('control-holder-fullscreen')[0]
        })
      ]),
      interactions: OlInteraction.defaults({
        altShiftDragRotate: false,
        pinchRotate: false
      }),
      target: this.id,
      layers: [],
      view: new OlView({
        projection: 'EPSG:3857',
        zoom: this.zoom,
        maxZoom: 20,
        minZoom: 3,
        extent: [-Math.PI * 6378137, -Math.PI * 6378137, Math.PI * 6378137, Math.PI * 6378137]
      })
    })

    this.map.getView().on('change:resolution', evt => {
      this.resolution = this.map.getView().getResolution()
    })

    this.setCursorOnHover()
    this.addLayers()
    this.addLonlatMarker()
    this.zoomToBestExtent()
    this.addDistanceInteraction()
    this.directionAntennes()

    this.refreshSimulationsFacadeLayer(this.isPNSEActif)
    this.refreshSimulationsSolLayer(this.isPNSEActif)

    let fsChangeType = this.fullscreenchangeType()
    if (fsChangeType) {
      document.addEventListener(fsChangeType, this.handleResize)
    }
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('onorientationchange', this.handleResize)
    this.addLocationTracker()
    this.addExtentListener()

    _.defer(this.handleResize)

    if (!(this.lon || this.lat || this.mapid)) {
      let hideSearchHelpNotificationPnse = storeJs.get('cr:hide-info-pnse-notification')
      if (this.$store.state.simulations.show && !hideSearchHelpNotificationPnse) {
        const modal = document.getElementById('pnse-notification')
        modal.classList.add('active')
      }
      // Accès direct, on met en évidence la recherche d'adresse
      let searchAdresseEl = document.getElementsByClassName('map_search_bar')[0]
      let hideSearchHelpNotification = storeJs.get('cr:hide-search-help-notification')
      if (!browser().mobile && !hideSearchHelpNotification && !this.$store.state.simulations.show) {
        this.$notify({
          group: 'search-help-notification',
          type: 'info',
          text: this.$t("message['Entrez une adresse pour trouver un lieu. J ai compris, ne plus voir cette information.']"),
          duration: 3800
        })
        let olViewportEl = document.getElementsByClassName('ol-viewport')[0]
        searchAdresseEl.classList.add('em')
        olViewportEl.style.opacity = 0.2
        setTimeout(h => {}, 2300)
        setTimeout(h => {
          searchAdresseEl.classList.remove('em')
          olViewportEl.style.opacity = 1
        }, 4500)
      }
      searchAdresseEl.focus()
    }

    // Ecoute du swipe de la partie droite pour affichage/masquage des réglages
    let rightContent = document.getElementById('right-content')
    swipeListener(rightContent)
    rightContent.addEventListener('swipe', e => {
      let directions = e.detail.directions
      if (directions.top || directions.bottom) {
        return
      }
      var slider = document.getElementsByClassName('vue-slider-state-drag')
      if (directions.left) {
        this.toggleSidebar(true)
      } else if (directions.right && slider.length === 0) {
        this.toggleSidebar(false)
      }
    })

    if (this.lon && this.lat) {
      this.getTerritoire(this.lon, this.lat)
    }

    rightContent.addEventListener('click', this.closeDropdownOnClickOutside)
  },

  beforeDestroy() {
    let fsChangeType = this.fullscreenchangeType()
    if (fsChangeType) {
      document.removeEventListener(fsChangeType, this.handleResize)
    }
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('onorientationchange', this.handleResize)
    EventBus.$off(eventTypes.OPEN_SUPPORTS)
    EventBus.$off(eventTypes.OPEN_MESURES)
    if (document.getElementById('right-content')) {
      document.getElementById('right-content').removeEventListener('click', this.closeDropdownOnClickOutside)
    }
  },

  methods: {
    print() {
      // Si mobile : export d'image, sinon pdf
      const br = browser()
      if (br.mobile) {
        this.exportMap()
      } else {
        new MapPrinter(this.map).execute()
      }
    },
    clickOSM() {
      const osm = this.findLayer(this.layerOpenStreet)
      const ign = this.findLayer(this.layerGeo)
      const ortho = this.findLayer(this.layerOrtho)
      if (!osm || !ign || !ortho) return

      // si simulations est désactivé → clickOSM ne fait rien
      if (!this.$store.state.simulations.show) return

      // inverse showBackground
      this.$store.state.simulations.showBackground = !this.$store.state.simulations.showBackground
      const hideBackground = this.$store.state.simulations.showBackground

      if (hideBackground) {
        // tout masquer
        osm.setVisible(false)
        ign.setVisible(false)
        ortho.setVisible(false)
      } else {
        // seul le calque sélectionné est visible
        const currentIgnLayer = this.$store.state.ign
        osm.setVisible(currentIgnLayer === osm.get('layerName'))
        ign.setVisible(currentIgnLayer === ign.get('layerName'))
        ortho.setVisible(currentIgnLayer === ortho.get('layerName'))
      }
    },
    onSimulationsChange() {
      const current = this.$store.state.simulations.show
      // inverse show
      this.$store.state.simulations.show = !current

      // chaque fois qu'on active/désactive simulations, on reset showBackground
      this.$store.state.simulations.showBackground = false

      // met à jour la visibilité des calques immédiatement
      this.updateLayers()
    },
    updateLayers() {
      const osm = this.findLayer(this.layerOpenStreet)
      const ign = this.findLayer(this.layerGeo)
      const ortho = this.findLayer(this.layerOrtho)
      if (!osm || !ign || !ortho) return

      if (!this.$store.state.simulations.show) {
        // simulations désactivé → on affiche seulement le calque actif
        const currentIgnLayer = this.$store.state.ign
        osm.setVisible(currentIgnLayer === osm.get('layerName'))
        ign.setVisible(currentIgnLayer === ign.get('layerName'))
        ortho.setVisible(currentIgnLayer === ortho.get('layerName'))
      } else {
        // simulations activé → rien à faire ici, clickOSM gère showBackground
      }
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    exportMap() {
      new MapExporter(this.map).execute()
    },
    changeExport() {
      this.errorDownload = false
    },
    exportCarte() {
      if (this.$store.state.localisation.active) {
        this.open('download_map')
      } else {
        this.downloadMap('emprise')
      }
    },
    switchTerritory(territory) {
      if (territory) {
        if (territory.codeign !== this.selectedTerritory.codeign) {
          this.selectedTerritory = territory
          this.isTerritoire = true
          this.isFrance = territory.codeign === 'FXX' // France métropolitaine
          this.$store.state.localisation.active = false // Pour afficher les antennes du territoire
          this.isDropdownOpen = false // Fermer la liste déroulante
          this.changeTerritoryRoute(territory)
          this.chargeOperateurs(territory.codeign)
        }
      }
    },
    changeTerritory(territory) {
      if (territory) {
        if (territory.codeign !== this.selectedTerritory.codeign) {
          this.selectedTerritory = territory
          this.chargeOperateurs(territory.codeign)
        }
      } else {
        this.selectedTerritory = this.territoires[this.territoires.length - 1]
        this.$store.state.supports.tm.operateurs = []
      }
    },
    changeTerritoryRoute(territoire) {
      this.$router.push('/cartographie/lonlat/' + territoire.lon + '/' + territoire.lat)
    },
    chargeOperateurs(codeIgnTerritoire) {
      axios.get('api/v1/operateursbyterritoire/' + codeIgnTerritoire)
        .then((response) => {
          if (response.data) {
            this.$store.state.supports.tm.operateurs = []
            response.data.operateurs.forEach((operateur) => {
              this.$store.state.supports.tm.operateurs.push({...operateur, show: true})
            })
          }
        })
        .catch((error) => {
          console.error('operateurs', error)
        })
    },
    getTerritoire(lon, lat) {
      if (!isNaN(lon) && !isNaN(lat)) {
        axios.get('/api/v1/localisation/territoire/' + lon + '/' + lat)
          .then((response) => {
            if (response.data) {
              // Actualiser le territoire
              let codeign = response.data.codeign
              let newTer = this.territoires.find(t => t.codeign === codeign)
              this.changeTerritory(newTer)
            } else {
              this.changeTerritory(undefined)
            }
          })
          .catch(function(error) {
            console.error('terrirtoires', error)
          })
      }
    },
    typeExportLocalisation() {
      var tabTypeExport = []
      this.typeExport.forEach(type => {
        if (this.localisationInfo != null && (type.code === this.localisationInfo.type || type.code === 'EMP')) {
          tabTypeExport.push(type)
        }
      })
      return tabTypeExport
    },

    downloadMap(typeExport) {
      if (typeExport != null) {
        var extent = this.map.getView().calculateExtent()
        extent = OlProj.transformExtent(extent, this.map.getView().getProjection().getCode(), 'EPSG:4326')

        var params = {
          'commune': typeExport === 'commune' && this.localisationInfo && this.localisationInfo.type === 'COM' ? this.localisationInfo.id : null,
          'departement': typeExport === 'departement' && this.localisationInfo && this.localisationInfo.type === 'DEP' ? this.localisationInfo.id : null,
          'fauxdepartement': typeExport === 'fauxdepartement' && this.localisationInfo && this.localisationInfo.type === 'FDEP' ? this.localisationInfo.id : null,
          'region': typeExport === 'region' && this.localisationInfo && this.localisationInfo.type === 'REG' ? this.localisationInfo.id : null,
          'categories': this.supportsUrlType,
          'operateurs': this.operateurs,
          'operateursnot': this.operateursnot,
          'operateurautre': this.operateursAutre,
          'technologies': this.technologies,
          'systeme': this.systeme,
          'enservice': this.$store.state.supports.tm.active,
          'stationsRadioelec': this.$store.state.mesures.stations.show,
          'objetsCom': this.$store.state.mesures.objets.show,
          'anciennete': this.$store.state.mesures.anciennete,
          'valeurLimiteMin': this.$store.state.mesures.niveaux[0],
          'valeurLimiteMax': this.$store.state.mesures.niveaux[1],
          'sol': this.$store.state.simulations.sol.show,
          'facade': this.$store.state.simulations.facade.show,
          'bbox': typeExport === 'emprise' && extent.toString() ? extent.toString() : null,
          'wkt': null,
          'type': typeExport === 'emprise' ? 'bbox' : null,
          'idUtilisateur': this.$store.state.user.id
        }

        const options = {
          url: '/api/v1/export',
          method: 'POST',
          params: params
        }

        var self = this
        axios(options)
          .then((response) => {
            if (response.status === 200) {
              this.$notify({
                group: 'general-notification',
                type: 'success',
                text: this.$t("message['Votre demande a été prise en compte. Le lien de téléchargement des données demandées va vous être communiqué par messagerie dans quelques minutes.']"),
                duration: 5800
              })
              this.selectedExport = null
              this.errorDownload = false
              this.close('download_map')
            }
          })
          .catch(function(error) {
            if (error.response.status === 400) {
              self.$notify({
                group: 'general-notification',
                type: 'warn',
                text: self.$t("message['L emprise de la carte est trop importante. Merci de zoomer.']"),
                duration: 5800
              })
            } else {
              self.$notify({
                group: 'general-notification',
                type: 'error',
                text: self.$t("message['Une erreur est survenue lors de la demande d export des donnees']"),
                duration: 5800
              })
              console.error('export', error)
            }
            self.selectedExport = null
            self.errorDownload = false
            self.close('download_map')
          })
      }
    },

    setCursorOnHover() {
      this.map.on('pointermove', evt => {
        var pixel = this.map.getEventPixel(evt.originalEvent)
        var hit = this.map.hasFeatureAtPixel(pixel)
        document.getElementById(this.map.getTarget()).style.cursor = (hit ? 'pointer' : 'auto')
      })
    },

    getAzimut(evt, azimutPopup) {
      /* Cache l'azimut si le niveau de zoom n'est pas assez grand */
      if (this.map.getView().getZoom() < 16) {
        var ficheantenne = document.getElementById('ficheantennePopup')
        ficheantenne.style.display = 'none'
      } else {
        /* Vérifie si les antennes sont affichées et si le clique n'a pas eu lieu sur l'icône fiche mesure/rapport */
        if (document.getElementById('direction_antennes').checked && this.displayFicheAntenne && document.getElementsByClassName('modal_overlay showfiche').length === 0) {
          /* Création de l'url permettant la recherche de l'antenne la plus proche du clique/survole */
          let layer = this.findLayer('Direction')
          var viewResolution = (this.map.getView().getResolution())
          var url = layer.getSource().getGetFeatureInfoUrl(
            evt.coordinate, viewResolution, this.map.getView().getProjection().getCode(), {'INFO_FORMAT': 'application/json', 'TOLERANCE': '0'})

          axios.get(url).then(response => {
            if (response.data) {
              var infoAntenne = response.data
              if (infoAntenne.features[0] != null) {
                var azimut = infoAntenne.features[0].properties.azimut
                /* On récupère le contenu html de la popup affichant l'azimut et on l'affiche aux coordonnées récupérées */
                var ficheantenneContenu = document.getElementById('ficheantenneContent')
                ficheantenneContenu.innerHTML = azimut + '°'

                var ficheantenne = document.getElementById('ficheantennePopup')

                azimutPopup.setElement(ficheantenne)
                ficheantenne.style.display = 'block'
                this.map.addOverlay(azimutPopup)
                azimutPopup.setPosition(infoAntenne.features[0].geometry.coordinates[0][1])
              }
            }
          }
          ).catch(error => { console.error(error) })
        } else {
          if (document.getElementsByClassName('modal_overlay showfiche').length === 0) {
            this.displayFicheAntenne = true
          }
        }
      }
    },

    directionAntennes() {
      var azimutPopup = new OlOverlay({
        element: null,
        stopEvent: false
      })
      this.map.on('singleclick', evt => {
        this.getAzimut(evt, azimutPopup)
      })
      if (!browser().mobile) {
        var timer
        this.map.on('pointermove', function(evt) {
          clearInterval(timer)
          timer = setTimeout(function() {
            this.getAzimut(evt, azimutPopup)
          }.bind(this), 500)
        }, this)
      }
    },

    fullscreenchangeType() {
      let fsChangeType = null
      const body = document.body
      if (body.webkitRequestFullscreen) {
        fsChangeType = 'webkitfullscreenchange'
      } else if (body.mozRequestFullScreen) {
        fsChangeType = 'mozfullscreenchange'
      } else if (body.msRequestFullscreen) {
        fsChangeType = 'MSFullscreenChange'
      } else if (body.requestFullscreen) {
        fsChangeType = 'fullscreenchange'
      }
      return fsChangeType
    },

    isFullscreenMode() {
      return document.getElementsByClassName('ol-full-screen-true').length > 0
    },

    handleResize(event) {
      // Hauteurs des élements body, mymap et son parent en fonction des hauteurs combinées window / documentElement
      // Semble impossible à réaliser en css
      // Test : avec Android jouer avec l'apparition de la barre d'adresse du navigateur
      let mh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      let height = null
      if (this.isFullscreenMode()) {
        // Cas particulier : Fullscreen Openlayers
        height = '100%'
      } else {
        let header = document.getElementsByTagName('header')[0]
        let footer = document.getElementsByTagName('footer')[0]
        let toBeRemoved = header.clientHeight + footer.clientHeight
        height = 'calc(' + mh + 'px - ' + toBeRemoved + 'px)'
      }
      let mymapEl = document.getElementsByClassName('mymap')[0]
      mymapEl.style.height = height
      mymapEl.parentElement.height = height
      document.body.style.height = mh + 'px'

      // Changement de taille du navigateur => redimensionnenement de la carte
      setTimeout(function() {
        this.map.updateSize()
      }.bind(this), 500)
    },

    toggleDistance() {
      let activate = !this.measuringTool.getActive()
      if (!activate) {
        // TODO vider couche layer et tooltip
      }
      this.measuringToolActive = activate
      this.measuringTool.setActive(activate)
    },
    refreshSupportsLayer() {
      let layer = this.findLayer('Supports')
      layer.getSource().getSource().clear()
    },
    refreshMesuresLayer() {
      let layer = this.findLayer('Mesures')
      layer.getSource().getSource().clear()
    },
    refreshSimulationsSolLayer(activated) {
      let layer = this.findLayer(this.layerHorizontal)
      layer.setVisible(activated && this.simulationsVisible && this.simulationsSolUrlBase)
    },

    refreshSimulationsFacadeLayer(activated) {
      let layer = this.findLayer(this.layerFacade)
      layer.setVisible(activated && this.simulationsVisible && this.simulationsFacadeUrlBase)
    },

    fetchMap() {
      this.zoomToBestExtent()
      let lon = Number.parseFloat(this.$route.params.lon)
      let lat = Number.parseFloat(this.$route.params.lat)
      this.getTerritoire(lon, lat)
    },
    zoomToBestExtent() {
      let zoom = this.zoom
      if (this.mapid) {
        this.setSelectedMapDetails(this.mapid)
      } else if (this.lon && this.lat) {
        let center = OlProj.transform(
          [this.lon, this.lat], 'EPSG:4326', 'EPSG:3857')

        if (this.isTerritoire) {
          this.isTerritoire = false
          this.isFrance ? zoom = 7 : zoom = 9

          this.map.getView().animate({
            center: center,
            zoom: zoom,
            duration: 1000
          })
        } else if (this.$store.state.localisation.filter) {
          let minLonLat = OlProj.transform([(Number(this.$store.state.localisation.filter.minlon)), (Number(this.$store.state.localisation.filter.minlat))], 'EPSG:4326', 'EPSG:3857')
          let maxLonLat = OlProj.transform([(Number(this.$store.state.localisation.filter.maxlon)), (Number(this.$store.state.localisation.filter.maxlat))], 'EPSG:4326', 'EPSG:3857')
          // Rectangle englobant l'étendue de l'emprise
          const extent = [minLonLat[0], minLonLat[1], maxLonLat[0], maxLonLat[1]]
          // Ajuster la vue de la carte pour couvrir l'extent
          this.map.getView().fit(extent, {
            padding: [-300, 0, -300, 0],
            duration: 1000
          })
        } else {
          this.map.getView().animate({
            center: center,
            zoom: zoom,
            duration: 1000
          })
        }

        this.lonlatMarker.setPosition(center)
      } else {
        // Etendue sauvegardée ?
        let extentInfo = storeJs.get('cr:extent')
        if (extentInfo) {
          let extent3857 = OlProj.transformExtent(extentInfo.extent, extentInfo.projection, this.map.getView().getProjection().getCode())
          this.map.getView().fit(extent3857)
        } else {
          // Zoom générique
          // Paris
          let paris = [256805.64470225616, 6249216.947446961, 265705.78118321137, 6252690.054919669]
          this.map.getView().fit(paris)
          // // France
          // let france4326 = [-5.537109, 39.622615, 10.239258, 52.038977]
          // let france = OlProj.transformExtent(
          //       france4326, 'EPSG:4326', 'EPSG:3857')
          // this.map.getView().fit(france)
        }

        // Sur mobile, on zoome sur la prochaine position connue
        if (browser().mobile) {
          this.nextPositionZoomOn = true
        }
      }
    },
    setSelectedMapDetails(mapid) {
      axios.get('/api/v1/cartes/' + mapid)
        .then((map) => {
          if (map.data.data) {
            var mapData = map.data.data
            // Suppports
            this.$store.state.supports.show = mapData.siteVisible
            this.$store.state.supports.categories.TEL.show = mapData.siteTm
            this.$store.state.supports.categories.TNT.show = mapData.siteTv
            this.$store.state.supports.systemes.FM.show = mapData.siteRadioFm
            this.$store.state.supports.systemes.AM.show = mapData.siteRadioAm
            this.$store.state.supports.systemes.RNT.show = mapData.siteRadioRnt
            this.$store.state.supports.categories.AUTRES.show = mapData.siteAutre
            this.$store.state.supports.categories.PMR.show = mapData.siteRmp
            this.$store.state.supports.categories.FH.show = mapData.siteFh
            this.$store.state.supports.tm.operateurs.forEach((value) => {
              value.show = _.includes(mapData.siteTmOpe, value.id)
            })
            Object.entries(this.$store.state.supports.tm.technologies).forEach(([key, value]) => {
              value.show = _.includes(mapData.siteTmTechno, key)
            })
            this.$store.state.supports.tm.active = mapData.siteTmSite
            this.$store.state.supports.direction = mapData.siteDirection
            // mesures
            this.$store.state.mesures.show = mapData.mesVisible
            this.$store.state.mesures.niveaux[0] = Math.round(mapData.mesValeursMin, 0)
            this.$store.state.mesures.niveaux[1] = Math.round(mapData.mesValeursMax, 0)
            this.$store.state.mesures.anciennete = mapData.mesAnciennete
            this.$store.state.mesures.objets.show = mapData.mesOc
            this.$store.state.mesures.stations.show = mapData.mesRadioelec

            this.$store.state.simulations.sol.show = mapData.simSol
            this.$store.state.simulations.facade.show = mapData.simFacade

            // Filtre par commune/département/région ?
            var type = ''
            var id = ''
            this.$store.state.localisation.active = false
            if (mapData.commune) {
              this.$store.state.localisation.active = true
              type = 'COM'
              id = mapData.commune
            } else if (mapData.departement) {
              this.$store.state.localisation.active = true
              type = 'DEP'
              id = mapData.departement
            } else if (mapData.fauxdepartement) {
              this.$store.state.localisation.active = true
              type = 'FDEP'
              id = mapData.fauxdepartement
            } else if (mapData.region) {
              this.$store.state.localisation.active = true
              type = 'REG'
              id = mapData.region
            }
            if (this.$store.state.localisation.active) {
              // avec celui qui n'est pas vide : mapData.commune || mapData.departement || mapData.fauxdepartement || mapData.region
              axios.get('/api/v1/localisation', {
                params: {
                  id: id,
                  type: type
                }
              })
                .then((response) => {
                  if (response.data) {
                    // Zoom sur la localisation
                    this.$store.state.localisation.filter = response.data
                    let lon = (Number(response.data.maxlon) + Number(response.data.minlon)) / 2.0
                    let lat = (Number(response.data.maxlat) + Number(response.data.minlat)) / 2.0
                    this.$router.push('/cartographie/lonlat/' + lon + '/' + lat)
                  }
                })
                .catch(function(error) {
                  console.error('communes', error)
                })
            } else {
              this.zoomtoExtent(mapData.etendue)
            }
          } else {
            this.$router.push('/')
          }
        })
        .catch(function(error) {
          console.error('mymap', error)
        })
    },
    zoomtoExtent(extent) {
      // Etendue sauvegardée ?
      var separatedChar = extent.split(',')
      var separated = _.map(separatedChar, function(o) {
        return Number(o)
      })
      var extentb = OlProj.transformExtent(separated, 'EPSG:4326', this.map.getView().getProjection().getCode())
      this.map.getView().fit(extentb)
    },
    centerOnLocation() {
      if (this.position) {
        let currentResolution = this.map.getView().getResolution()
        if (currentResolution > 5) {
          this.map.getView().setResolution(5)
        }
        this.map.getView().setCenter(this.position)
      } else {
        this.$notify({
          group: 'general-notification',
          type: 'error',
          text: this.$t("message['Autorisation position refusée']"),
          duration: 10000
        })
      }
    },
    zoomPlus() {
      this.zoomDelta(1)
    },
    zoomMinus() {
      this.zoomDelta(-1)
    },
    zoomDelta(delta) {
      let view = this.map.getView()
      let duration = 200

      var currentResolution = view.getResolution()
      if (currentResolution) {
        var newResolution = view.constrainResolution(currentResolution, delta)
        if (duration > 0) {
          if (view.getAnimating()) {
            view.cancelAnimations()
          }
          view.animate({
            resolution: newResolution,
            duration: duration,
            easing: OlEasing.EaseOut
          })
        } else {
          view.setResolution(newResolution)
        }
      }
    },

    addOSMLayers() {
      this.map.addLayer(this.createOSMLayer(this.layerOpenStreet))
    },
    createOSMLayer(layerName) {
      return new OlLayerTile({
        source: new OlSourceOSM({
          wrapX: true,
          crossOrigin: 'anonymous'
        }),
        layerName: this.layerOpenStreet,
        opacity: 1,
        visible: true
      })
    },

    findLayer(code, layers) {
      let returned
      if (!layers) {
        layers = this.map.getLayers()
      }
      layers.forEach(function(layer) {
        if (layer instanceof OlLayerGroup) {
          returned = this.findLayer(code, layer.getLayers())
        } else {
          if (layer.get('layerName') === code) {
            returned = layer
          }
        }
      })
      return returned
    },
    findInteraction(interactionClass) {
      let returned
      this.map.getInteractions().forEach(function(interaction) {
        // TODO revoir la discrimination
        if (interaction instanceof interactionClass) {
          returned = interaction
          return false
        }
      })
      return returned
    },

    findDistanceInteraction() {
      return this.findInteraction(OlInteractionDraw)
    },

    addExtentListener() {
      // On sauvegarde l'étendue pour une arrivée ultérieure sans position fixée
      this.map.on('moveend', function(evt) {
        let view = this.map.getView()
        this.currentZoom = view.getZoom()
        let extentInfo = {
          projection: view.getProjection().getCode(),
          extent: view.calculateExtent()
        }
        if (extentInfo.extent && extentInfo.extent.length === 4 &&
          extentInfo.extent[0] && typeof (extentInfo.extent[0]) === 'number') {
          storeJs.set('cr:extent', extentInfo)
        }

        const center = this.map.getView().getCenter()
        const [lon, lat] = OlProj.toLonLat(center)
        this.getTerritoire(lon, lat)
      }, this)
    },

    addLocationTracker() {
      // Overlay avec le noeud location
      this.marker = new OlOverlay({
        element: document.getElementById('location-marker'),
        positioning: 'bottom-left',
        stopEvent: false
      })
      this.map.addOverlay(this.marker)
      this.geolocation = new OlGeolocation({
        tracking: true,
        trackingOptions: {maximumAge: Infinity, timeout: 1000},
        projection: this.map.getView().getProjection()
      })
      // Changement de position : on conserve la valeur
      this.geolocation.on('change:position', function(evt) {
        let p = this.geolocation.getPosition()
        if (p) {
          this.position = p
        }
        this.marker.setPosition(this.position)
        if (this.nextPositionZoomOn) {
          this.nextPositionZoomOn = false
          this.centerOnLocation()
        }
      }, this)
    },

    addLonlatMarker() {
      this.lonlatMarker = new OlOverlay({
        element: document.getElementById('lonlat-marker'),
        positioning: 'bottom-left',
        stopEvent: false
      })
      this.map.addOverlay(this.lonlatMarker)
    },

    addDistanceInteraction() {
      var measureTooltipElement = document.createElement('div')
      measureTooltipElement.className = 'tooltip tooltip-measure'
      let measureTooltip = new OlOverlay({
        element: measureTooltipElement,
        offset: [0, -15],
        positioning: 'bottom-center'
      })
      this.map.addOverlay(measureTooltip)
      let source = new OlSourceVector()
      let vectorLayer = new OlLayerVector({
        source: source
      })
      this.map.addLayer(vectorLayer)
      let measuringTool = new OlInteractionDraw({
        type: 'LineString',
        source: vectorLayer.getSource()
      })
      measuringTool.setActive(false)
      measuringTool.on('drawstart', function(event) {
        // tooltip
        vectorLayer.getSource().clear()
        event.feature.on('change', function(event) {
          var measurement = OlSphere.getLength(event.target.getGeometry())
          var output = measurement > 100 ? (measurement / 1000).toFixed(2) + 'km' : measurement.toFixed(2) + 'm'
          measureTooltipElement.innerHTML = output
          measureTooltip.setPosition(event.target.getGeometry().getLastCoordinate())
        })
      })
      measuringTool.on('drawstart', function(event) {
        measureTooltipElement.className = 'tooltip tooltip-static'
        measureTooltip.setOffset([0, -7])
      })
      measuringTool.on('change:active', function(evt) {
        if (evt.oldValue) {
          // Nettoyage
          vectorLayer.getSource().clear()
          measureTooltip.setPosition([0, 0])
        }
        // Ouverture des fiches que lorsqu'on ne réalise pas une mesure
        evt.target.getMap().getInteractions().forEach(i => {
          if (i.interactionName === 'showFiche') {
            i.setActive(evt.oldValue)
          }
        })
      })
      this.map.addInteraction(measuringTool)
      this.measuringTool = measuringTool
    },

    addLayers() {
      this.addOSMLayers()
      this.addIGNLayers()
      this.addCommuneLayer()
      this.addDepartementLayer()
      this.addFauxDepartementLayer()
      this.addRegionLayer()
      this.addDirectionLayer()
      this.addOperateurLayer()

      this.addVectorLayers()
    },

    addIGNLayers() {
      this.map.addLayer(this.createCarteLayer())
      this.map.addLayer(this.createPhotoLayer())
      this.map.addLayer(this.createSolLayer())
      this.map.addLayer(this.createFacadeLayer())
    },
    createCarteLayer() {
      return this.createIgnLayer(this.layerGeo, 18, 'image/png')
    },
    createPhotoLayer() {
      return this.createIgnLayer(this.layerOrtho, 22, 'image/jpeg')
    },
    createSolLayer() {
      return this.createSimulationsLayer(this.layerHorizontal, 22, 'image/png')
    },
    createFacadeLayer() {
      return this.createSimulationsLayer(this.layerFacade, 22, 'image/png')
    },
    createIgnLayer(layerName, maxResolutionNum, format) {
      var resolutions = []
      var matrixIds = []
      var proj3857 = OlProj.get('EPSG:3857')
      var maxResolution = OlExtent.getWidth(proj3857.getExtent()) / 256

      for (var i = 0; i < maxResolutionNum; i++) {
        matrixIds[i] = i.toString()
        resolutions[i] = maxResolution / Math.pow(2, i)
      }

      var tileGrid = new OlTilegridWMTS({
        origin: [-20037508, 20037508],
        resolutions: resolutions,
        matrixIds: matrixIds
      })

      var ignSource = new OlSourceWMTS({
        url: this.urlGeoplateforme,
        layer: layerName,
        matrixSet: 'PM',
        format: format,
        projection: 'EPSG:3857',
        tileGrid: tileGrid,
        style: 'normal',
        // Pour exporter la map
        crossOrigin: 'anonymous',
        wrapX: true
      })

      var layer = new OlLayerTile({
        preload: Infinity,
        layerName: layerName,
        visible: this.ign === layerName,
        source: ignSource,
        opacity: 1
      })
      return layer
    },

    createSimulationsLayer(layerName, maxResolutionNum, format) {
      var resolutions = []
      var matrixIds = []
      var proj900913 = OlProj.get('EPSG:900913') // layer disponible uniquement sous cette projection
      var maxResolution = OlExtent.getWidth(proj900913.getExtent()) / 256

      for (var i = 0; i < maxResolutionNum; i++) {
        matrixIds[i] = 'EPSG:900913:' + i // Le nom des TileMatrix est de la forme EPSG:900913:0 à EPSG:900913:30
        resolutions[i] = maxResolution / Math.pow(2, i)
      }

      var tileGrid = new OlTilegridWMTS({
        origin: [-20037508, 20037508],
        resolutions: resolutions.slice(14),
        matrixIds: matrixIds.slice(14)
      })

      var coexyaSource = new OlSourceWMTS({
        url: this.urlCoexya,
        layer: layerName,
        matrixSet: 'EPSG:900913', // on ajoute l'intervalle adapté avec le matrixId via le tileGrid qu'on a créé
        format: format,
        projection: 'EPSG:900913',
        tileGrid: tileGrid,
        style: 'normal',
        // Pour exporter la map
        crossOrigin: 'anonymous',
        wrapX: true
      })

      // si c'est un layer façade, l'opacité doit être à 1, sinon on laisse à 0.7 sur la couche pour voir le fond de carte derrière.
      var opacityLayer = 0.6
      if (layerName === this.layerFacade) {
        opacityLayer = 1
      }

      var layer = new OlLayerTile({
        maxResolution: 19.6,
        preload: Infinity,
        layerName: layerName,
        visible: this.simulationsVisible,
        source: coexyaSource,
        opacity: opacityLayer
      })
      return layer
    },

    addDirectionLayer() {
      let layer = new OlLayerImage({
        layerName: 'Direction',
        source: new OlSourceImageWMS({
          url: '/geoserver/cartoradio/wms',
          params: this.directionParamsBase,
          ratio: 1,
          serverType: 'geoserver'
        }),
        maxResolution: 4,
        visible: this.directionTMVisible
      })
      this.map.addLayer(layer)
    },
    refreshDirectionLayer() {
      let layer = this.findLayer('Direction')
      layer.getSource().updateParams(this.directionParamsBase)
    },

    addOperateurLayer() {
      let layer = new OlLayerImage({
        layerName: 'Operateur',
        source: new OlSourceImageWMS({
          url: '/geoserver/cartoradio/wms',
          params: this.operateurParamsBase,
          ratio: 1,
          serverType: 'geoserver'
        }),
        maxResolution: 4,
        visible: this.operateurVisible
      })
      this.map.addLayer(layer)
    },
    refreshOperateurLayer() {
      let layer = this.findLayer('Operateur')
      layer.getSource().updateParams(this.operateurParamsBase)
    },
    addDepartementLayer() {
      let layer = new OlLayerImage({
        layerName: 'Departement',
        source: new OlSourceImageWMS({
          url: '/geoserver/cartoradio/wms',
          params: this.departementParamsBase,
          ratio: 1,
          serverType: 'geoserver'
        }),
        maxResolution: 2000,
        visible: this.localisationVisible
      })
      this.map.addLayer(layer)
    },
    refreshDepartementLayer() {
      let layer = this.findLayer('Departement')
      layer.getSource().updateParams(this.departementParamsBase)
    },
    addFauxDepartementLayer() {
      let layer = new OlLayerImage({
        layerName: 'FauxDepartement',
        source: new OlSourceImageWMS({
          url: '/geoserver/cartoradio/wms',
          params: this.fauxDepartementParamsBase,
          ratio: 1,
          serverType: 'geoserver'
        }),
        maxResolution: 2000,
        visible: this.localisationVisible
      })
      this.map.addLayer(layer)
    },
    refreshFauxDepartementLayer() {
      let layer = this.findLayer('FauxDepartement')
      layer.getSource().updateParams(this.fauxDepartementParamsBase)
    },
    addRegionLayer() {
      let layer = new OlLayerImage({
        layerName: 'Region',
        source: new OlSourceImageWMS({
          url: '/geoserver/cartoradio/wms',
          params: this.regionParamsBase,
          ratio: 1,
          serverType: 'geoserver'
        }),
        maxResolution: 2000,
        visible: this.localisationVisible
      })
      this.map.addLayer(layer)
    },
    refreshRegionLayer() {
      let layer = this.findLayer('Region')
      layer.getSource().updateParams(this.regionParamsBase)
    },
    addCommuneLayer() {
      let layer = new OlLayerImage({
        layerName: 'Commune',
        source: new OlSourceImageWMS({
          url: '/geoserver/cartoradio/wms',
          params: this.communeParamsBase,
          ratio: 1,
          serverType: 'geoserver'
        }),
        maxResolution: 200,
        visible: this.localisationVisible
      })
      this.map.addLayer(layer)
    },
    refreshCommuneLayer() {
      let layer = this.findLayer('Commune')
      layer.getSource().updateParams(this.communeParamsBase)
    },
    addVectorLayers() {
      var suppLayer = this.createSupportsLayer()
      this.map.addLayer(suppLayer)
      this.map.addInteraction(new OlInteractionSelect({
        condition: function(evt) {
          return evt.type === 'pointermove' ||
            evt.type === 'singleclick'
        },
        layers: [suppLayer],
        style: this.supportsStyleHover
      }))

      var mesuLayer = this.createMesuresLayer()
      this.map.addLayer(mesuLayer)
      this.map.addInteraction(new OlInteractionSelect({
        condition: function(evt) {
          return evt.type === 'pointermove' ||
            evt.type === 'singleclick'
        },
        layers: [mesuLayer],
        style: this.mesuresStyleHover
      }))

      let select = new OlInteractionSelect({
        condition: function(evt) {
          return evt.type === 'click'
        },
        layers: [suppLayer, mesuLayer],
        style: this.selectedStyle
      })
      select.interactionName = 'showFiche'
      this.map.addInteraction(select)
      select.on('select', function(e) {
        let hashes = []
        let featureTypes = []
        e.selected.forEach(function(feature, index, features) {
          this.extractHashesFromFeature(feature, hashes, featureTypes)
        }, this)

        EventBus.$emit(
          featureTypes.indexOf('support') >= 0 ? eventTypes.OPEN_SUPPORTS : eventTypes.OPEN_MESURES,
          hashes)

        // L'événement doit être déclenché à nouveau pour ouvrir la fiche à nouveau
        // e.target : l'interaction "select"
        e.target.getFeatures().clear()
      }, this)
    },

    selectedStyle(feature, resolution) {
      let invisible = this.styleCache['invisible']
      if (!invisible) {
        invisible = new OlStyleStyle({})
        this.styleCache['invisible'] = invisible
      }
      return invisible
    },

    extractHashesFromFeature(feature, hashes, featureTypes) {
      if (!hashes) {
        hashes = []
      }
      let features = feature.get('features')
      if (features) {
        // cluster
        for (let realFeat of features) {
          this.extractHashesFromFeature(realFeat, hashes, featureTypes)
        }
      } else {
        hashes.push(feature.getId())
        if (feature.get('categories')) {
          if (featureTypes.indexOf('support') < 0) {
            featureTypes.push('support')
          }
        } else {
          if (featureTypes.indexOf('mesure') < 0) {
            featureTypes.push('mesure')
          }
        }
      }
      return hashes
    },

    createMesuresLayer() {
      let me = this
      let vectorSource = new OlSourceVector({
        format: new OlFormatGeoJSON(),
        url: this.mesuresUrl,
        strategy: OlLoadingstrategy.bbox,
        // Comportement par défaut →
        // loader: OlFeatureloader.xhr(this.supportsUrl, new OlFormatGeoJSON())
        loader: OlFeatureloader.loadFeaturesXhr(this.mesuresUrl, new OlFormatGeoJSON(),
          function(features, dataProjection) {
            if (features.length >= me.$store.state.params.nbMaxMesu) {
              // Zone dense : on masque la couche, on invalide la zone (car chargement partiel)
              // et on affiche un message. Dès que la vue change, on affiche à nouveau la couche
              // pour recommencer le processus
              me.findLayer('Mesures').setVisible(false)
              this.clear(true)
              me.map.once('movestart', () => {
                if (me.$store.state.mesures.show) {
                  me.findLayer('Mesures').setVisible(true)
                }
              })
              me.mesuresMaxDensityReached = true
              return
            }
            me.mesuresMaxDensityReached = false
            this.addFeatures(features)
          }, () => { console.error('mesures', 'chargement') })
      })
      let clusterSource = new OlSourceCluster({
        distance: 20,
        source: vectorSource
      })
      let layer = new OlLayerVector({
        layerName: 'Mesures',
        source: clusterSource,
        style: this.mesuresStyle,
        visible: this.mesuresVisible
      })

      return layer
    },

    mesuresStyleHover(feature, resolution) {
      return this.mesuresStyleCounter(feature, resolution, true)
    },
    mesuresStyle(feature, resolution) {
      return this.mesuresStyleCounter(feature, resolution, false)
    },
    mesuresStyleCounter(feature, resolution, hover) {
      var size = feature.get('features').length
      let url = '/static/img/mesures/MES_' + (hover === true ? 'H_' : '') + 'X.png'

      if (size < 2) {
        for (let realFeat of feature.get('features')) {
          if (realFeat.get('objet_communicant')[0]) {
            url = '/static/img/mesures/OBJ_' + (hover === true ? 'H_' : '') + 'X.png'
          } else {
            url = '/static/img/mesures/MES_' + (hover === true ? 'H_' : '') + 'X.png'
          }
        }
      } else {
        url = '/static/img/mesures/MES_' + (hover === true ? 'H_' : '') + 'X.png'
        if (_.find(feature.get('features'), o => { return o.get('objet_communicant')[0] }) === undefined) {
          url = '/static/img/mesures/MES_' + (hover === true ? 'H_' : '') + 'X.png'
        } else if (_.find(feature.get('features'), o => { return !o.get('objet_communicant')[0] }) === undefined) {
          url = '/static/img/mesures/OBJ_' + (hover === true ? 'H_' : '') + 'X.png'
        }
      }
      let lbl = size.toString()
      let cacheKey = url + lbl
      let cached = this.styleCache[cacheKey]
      if (!cached) {
        this.styleCache[cacheKey] = new OlStyleStyle({
          image: new OlStyleIcon({
            src: url,
            anchor: [0.5, 1]
          }),
          text: new OlStyleText({
            offsetY: -(24 / 2 + 2),
            text: lbl,
            fill: new OlStyleFill({
              color: '#fff'
            })
          })
        })
      }
      return this.styleCache[cacheKey]
    },

    mesuresUrl(extent) {
      let extent4326 = OlProj.transformExtent(extent, 'EPSG:3857', 'EPSG:4326')
      return this.mesuresUrlBase + '&bbox=' + extent4326
    },

    supportsUrl(extent) {
      let extent4326 = OlProj.transformExtent(extent, 'EPSG:3857', 'EPSG:4326')
      return this.supportsUrlBase + '&bbox=' + extent4326
    },

    createSupportsLayer() {
      let me = this
      let vectorSource = new OlSourceVector({
        format: new OlFormatGeoJSON(),
        url: this.supportsUrl,
        strategy: OlLoadingstrategy.bbox,
        // Comportement par défaut →
        // loader: OlFeatureloader.xhr(this.supportsUrl, new OlFormatGeoJSON())
        loader: OlFeatureloader.loadFeaturesXhr(this.supportsUrl, new OlFormatGeoJSON(),
          function(features, dataProjection) {
            if (features.length >= me.$store.state.params.nbMaxSupp) {
              // Zone dense : on masque la couche, on invalide la zone (car chargement partiel)
              // et on affiche un message. Dès que la vue change, on affiche à nouveau la couche
              // pour recommencer le processus
              me.findLayer('Supports').setVisible(false)
              this.clear(true)
              me.map.once('movestart', () => {
                if (me.$store.state.supports.show) {
                  me.findLayer('Supports').setVisible(true)
                }
              })
              me.supportsMaxDensityReached = true
              return
            }
            me.supportsMaxDensityReached = false
            this.addFeatures(features)
          }, () => { console.error('supports', 'chargement') })
      })
      let clusterSource = new OlSourceCluster({
        distance: 40,
        source: vectorSource
      })
      let layer = new OlLayerVector({
        layerName: 'Supports',
        source: clusterSource,
        style: this.supportsStyle,
        visible: this.supportsVisible
      })
      return layer
    },

    supportsStyleHover(feature, resolution) {
      return this.supportsStylePictos(feature, resolution, true)
    },

    supportsStyle(feature, resolution) {
      var size = feature.get('features').length
      let bigScale = resolution <= 0.000010728836059570312 // TODO voir sur quoi s'appuyer
      if (bigScale || (size < 2 && !this.supportsConsistent)) {
        return this.supportsStylePictos(feature, resolution, false)
      } else {
        return this.supportsStyleCounter(feature, resolution, false)
      }
    },
    supportsStylePictos(feature, resolution, hover) {
      let bigScale = resolution <= 0.000010728836059570312 // TODO voir sur quoi s'appuyer
      let extractData = this.getImgLegendSupport(feature, hover)
      let url = extractData.url
      let cacheKey = url + bigScale
      let cached = this.styleCache[cacheKey]
      if (!cached) {
        this.styleCache[cacheKey] = new OlStyleStyle({
          image: new OlStyleIcon({
            src: extractData.url,
            anchor: [0.5, 1]
          })
        })
      }
      return this.styleCache[cacheKey]
    },
    supportsStyleCounter(feature, resolution, hover) {
      var size = feature.get('features').length
      let url = '/static/img/support_X/SUP_X.png'
      let lbl = size.toString()
      let cacheKey = url + lbl
      let cached = this.styleCache[cacheKey]
      if (!cached) {
        this.styleCache[cacheKey] = new OlStyleStyle({
          image: new OlStyleIcon({
            src: url,
            anchor: [0.5, 1]
          }),
          text: new OlStyleText({
            offsetY: -(24 / 2 + 2),
            text: lbl,
            fill: new OlStyleFill({
              color: '#fff'
            })
          })
        })
      }
      return this.styleCache[cacheKey]
    },
    extractDataFromFeature(feature, data) {
      if (!data) {
        data = {
          s1: false,
          s2: false,
          s3: false,
          s4: false,
          s5: false,
          s6: false,
          s7: false,
          s8: false,
          b: false,
          f: false,
          o: false,
          s: false,
          d: false,
          u: false,
          c: false,
          m: false,
          r: false,
          t: false,
          p: false,
          n: false,
          v: false,
          i: false,
          z: false,
          h: false,
          w: false,
          g: false,
          y: false,
          q: false
        }
      }
      let features = feature.get('features')
      if (features) {
        // cluster
        for (let realFeat of features) {
          this.extractDataFromFeature(realFeat, data)
        }
      } else {
        let cat = feature.get('categories')
        data.s1 = data.s1 || cat.includes(1) === true
        data.s2 = data.s2 || cat.includes(2) === true
        data.s3 = data.s3 || cat.includes(3) === true
        data.s5 = data.s5 || cat.includes(5) === true
        data.s6 = data.s6 || cat.includes(6) === true

        let systemes = feature.get('systemes')
        data.s4 = data.s4 || systemes.includes('FM') === true
        data.s7 = data.s7 || systemes.includes('AM') === true
        data.s8 = data.s8 || systemes.includes('RNT') === true

        let exploit = feature.get('exploitants_tm')
        // On ne prend les opérateurs que si le support est identifié comme de la téléphonie (cas des antennes Digicel avec opérateur mais non téléphonie...)
        if (exploit && cat.includes(1) === true) {
          data.b = data.b || exploit.includes(this.CR_EXPLOITANTS_TM.BOUYGUES_TELECOM)
          data.f = data.f || exploit.includes(this.CR_EXPLOITANTS_TM.FREE_MOBILE)
          data.o = data.o || exploit.includes(this.CR_EXPLOITANTS_TM.ORANGE)
          data.s = data.s || exploit.includes(this.CR_EXPLOITANTS_TM.SFR)
          data.m = data.m || exploit.includes(this.CR_EXPLOITANTS_TM.MAORE_MOBILE)
          data.g = data.g || exploit.includes(this.CR_EXPLOITANTS_TM.GLOBALTEL)
          data.h = data.h || exploit.includes(this.CR_EXPLOITANTS_TM.DAUPHIN_TELECOM)
          data.w = data.w || exploit.includes(this.CR_EXPLOITANTS_TM.UTS_Caraibes)
          data.u = data.u || exploit.includes(this.CR_EXPLOITANTS_TM.OUTREMER_TELECOM)
          data.t = data.t || exploit.includes(this.CR_EXPLOITANTS_TM.TELCO_OI)
          data.n = data.n || exploit.includes(this.CR_EXPLOITANTS_TM.ONATI)
          data.q = data.q || exploit.includes(this.CR_EXPLOITANTS_TM.BPT)
          data.d = data.d || exploit.includes(this.CR_EXPLOITANTS_TM.DIGICEL)
          data.i = data.i || exploit.includes(this.CR_EXPLOITANTS_TM.VITI_SAS)
          data.p = data.p || exploit.includes(this.CR_EXPLOITANTS_TM.Gouv_Nelle_Calédonie_OPT)
          data.y = data.y || exploit.includes(this.CR_EXPLOITANTS_TM.SPM_TELECOM)
          data.z = data.z || exploit.includes(this.CR_EXPLOITANTS_TM.ZEOP)
          data.r = data.r || exploit.includes(this.CR_EXPLOITANTS_TM.SRR)
          data.v = data.v || exploit.includes(this.CR_EXPLOITANTS_TM.PMT_VODAFONE)
          data.c = data.c || exploit.includes(this.CR_EXPLOITANTS_TM.FREE_CARAIBES)
        }
      }
      return data
    },
    getImgLegendSupport(feature, hover) {
      let data = this.extractDataFromFeature(feature)
      let link = '/static/img/supports/SUP_' +
          (data.s1 ? 1 : '') + (data.s2 ? 2 : '') + (data.s3 ? 3 : '') + (data.s4 ? 4 : '') + (data.s5 ? 5 : '') + (data.s6 ? 6 : '') + (data.s7 ? 7 : '') + (data.s8 ? 8 : '') +
          ((data.s1) ? '_' + this.getCombinationOrdered(data) + '_' + this.selectedTerritory.codeign : '') +
          '.png'
      return {
        url: link
      }
    },
    /**
     * Renvoie la combinaison en ordre alphabetique pour eviter une incomprehension avec le fichier
     * Ex : OHWD != ODHW
     */
    getCombinationOrdered(data) {
      let combo = (data.b ? 'B' : '') + (data.s ? 'S' : '') + (data.o ? 'O' : '') + (data.f ? 'F' : '') +
          (data.m ? 'M' : '') + (data.q ? 'Q' : '') + (data.d ? 'D' : '') + (data.u ? 'U' : '') + (data.r ? 'R' : '') +
          (data.t ? 'T' : '') + (data.p ? 'P' : '') + (data.n ? 'N' : '') + (data.v ? 'V' : '') + (data.i ? 'I' : '') +
          (data.h ? 'H' : '') + (data.w ? 'W' : '') + (data.g ? 'G' : '') + (data.y ? 'Y' : '') + (data.c ? 'C' : '') +
          (data.z ? 'Z' : '')

      return combo.split('').sort().join('')
    },
    toggleSidebar(open) {
      this.$store.dispatch('sidebarToggle', open)
      setTimeout(function() {
        // Cf. https://github.com/NightCatSama/vue-slider-component#exceptions
        this.$refs.sliderMesuresAnciennete.refresh()
        this.$refs.sliderMesuresNiveaux.refresh()
      }.bind(this), 350)
    },
    switchIgnLayer() {
      const geoLayer = this.findLayer(this.layerGeo)
      const orthoLayer = this.findLayer(this.layerOrtho)
      const osmLayer = this.findLayer(this.layerOpenStreet)

      if (!geoLayer || !orthoLayer || !osmLayer) return

      let nextLayer

      // CAS : aucun fond actif
      if (!geoLayer.getVisible() && !orthoLayer.getVisible() && !osmLayer.getVisible()) {
        nextLayer = this.layerGeo
      } else {
        // Cycle normal basé sur la visibilité réelle
        if (geoLayer.getVisible()) nextLayer = this.layerOrtho
        else if (orthoLayer.getVisible()) nextLayer = this.layerOpenStreet
        else if (osmLayer.getVisible()) nextLayer = this.layerGeo
      }

      // Appliquer
      geoLayer.setVisible(nextLayer === this.layerGeo)
      orthoLayer.setVisible(nextLayer === this.layerOrtho)
      osmLayer.setVisible(nextLayer === this.layerOpenStreet)

      this.$store.state.ign = nextLayer
    },
    lonlat(lonlat) {
      this.$emit('lonlat', lonlat)
    },
    open: function(id) {
      var modal = document.getElementById(id)
      modal.classList.add('active')
    },
    close: function(id) {
      var modal = document.getElementById(id)
      modal.classList.remove('active')
    },

    saveMap: function() {
      if (this.savedMap !== '') {
        var suppTmOperateurs = []
        this.$store.state.supports.tm.operateurs.forEach((value) => {
          if (value.show) {
            suppTmOperateurs.push(value.id)
          }
        })

        var suppTmTechnologies = []
        var suppTmTechnologiesNot = []
        Object.entries(this.$store.state.supports.tm.technologies).forEach(([key, value]) => {
          if (value.show) {
            suppTmTechnologies.push(key)
          } else {
            suppTmTechnologiesNot.push(key)
          }
        })
        var extent = this.map.getView().calculateExtent()
        extent = OlProj.transformExtent(extent, this.map.getView().getProjection().getCode(), 'EPSG:4326')

        var params = {
          'idUser': this.$store.state.user.id,
          'nom': this.savedMap,
          'etendu': extent.toString(),
          'commune': this.localisationInfo && this.localisationInfo.type === 'COM' ? this.localisationInfo.id : null,
          'departement': this.localisationInfo && this.localisationInfo.type === 'DEP' ? this.localisationInfo.id : null,
          'fauxdepartement': this.localisationInfo && this.localisationInfo.type === 'FDEP' ? this.localisationInfo.id : null,
          'region': this.localisationInfo && this.localisationInfo.type === 'REG' ? this.localisationInfo.id : null,
          'mes_visible': this.$store.state.mesures.show,
          'mes_radioelec': this.$store.state.mesures.stations.show,
          'mes_oc': this.$store.state.mesures.objets.show,
          'mes_anciennete': this.$store.state.mesures.anciennete,
          'mes_valeurs_min': this.$store.state.mesures.niveaux[0],
          'mes_valeurs_max': this.$store.state.mesures.niveaux[1],
          'sim_sol': this.$store.state.simulations.sol.show,
          'sim_facade': this.$store.state.simulations.facade.show,
          'site_visible': this.$store.state.supports.show,
          'site_tm_ope': suppTmOperateurs,
          'site_tm_ope_autre': this.operateursAutre,
          'site_tm_techno': suppTmTechnologies,
          'site_tm_site': this.$store.state.supports.tm.active,
          'site_tm': this.$store.state.supports.categories.TEL.show,
          'site_tv': this.$store.state.supports.categories.TNT.show,
          'site_radio_fm': this.$store.state.supports.systemes.FM.show,
          'site_radio_am': this.$store.state.supports.systemes.AM.show,
          'site_radio_rnt': this.$store.state.supports.systemes.RNT.show,
          'site_rmp': this.$store.state.supports.categories.PMR.show,
          'site_fh': this.$store.state.supports.categories.FH.show,
          'site_autre': this.$store.state.supports.categories.AUTRES.show,
          'site_direction': this.directionTMVisible
        }
        const options = {
          url: '/api/v1/cartes',
          method: 'POST',
          params: params
        }
        axios(options)
          .then((response) => {
            if (response.data) {
              this.$store.state.maps.splice(this.$store.state.maps.length, 0, {
                'code': response.data.code,
                'nom': response.data.nom
              })
              this.$notify({
                group: 'general-notification',
                type: 'success',
                text: this.$t("message['La carte ']") + response.data.nom + this.$t("message[' a été enregistrée avec succès.']")
              })
              this.savedMap = ''
              this.close('save_maps')
            } else {
              this.$notify({
                group: 'general-notification',
                type: 'success',
                text: this.$t("message['Une erreur est survenue lors de l enregistrement de la carte']")
              })
            }
          })
          .catch(function(error) {
            console.error('mymap', error)
          })
      } else {
        this.errorSave = true
      }
    },
    openNotification() {
      let searchAdresseEl = document.getElementsByClassName('map_search_bar')[0]
      searchAdresseEl.classList.remove('em')
      let olViewportEl = document.getElementsByClassName('ol-viewport')[0]
      olViewportEl.style.opacity = 1
    },
    dontShowAnymoreSearchHelpNotification() {
      this.openNotification()
      // L'utilisateur ne souhaite plus voir l'information
      storeJs.set('cr:hide-search-help-notification', true)
      this.$notify({
        group: 'search-help-notification',
        clean: true
      })
    },
    dontShowAnymoreInfoPnseNotification() {
      // L'utilisateur ne souhaite plus voir l'information
      storeJs.set('cr:hide-info-pnse-notification', true)
      this.close('pnse-notification')
    },
    showStats() {
      if (this.$store.state.localisation.active && this.$store.state.localisation.filter != null) {
        this.getStatistiques()
        const br = browser()
        if (br.mobile) {
          this.toggleSidebar()
        }
      }
    },

    closeStats() {
      this.boolShowStats = false
      this.hideDetail()
    },

    onFilterChange() {
      if (this.boolShowStats) {
        this.getStatistiques()
      }
      if (this.boolShowDetail) {
        this.getDetail()
      }
      if (this.boolShowTechnos) {
        this.getOperateurTechno()
      }
      if (this.boolShowTechnosBandes) {
        this.resetNbTechnos()
        this.getOperateurTechnoBande()
      }
    },

    getStatistiques() {
      var params = {
        'commune': this.localisationInfo && this.localisationInfo.type === 'COM' ? this.localisationInfo.id : null,
        'departement': this.localisationInfo && this.localisationInfo.type === 'DEP' ? this.localisationInfo.id : null,
        'fauxdepartement': this.localisationInfo && this.localisationInfo.type === 'FDEP' ? this.localisationInfo.id : null,
        'region': this.localisationInfo && this.localisationInfo.type === 'REG' ? this.localisationInfo.id : null,
        'categories': this.supportsUrlType,
        'operateurs': this.operateurs,
        'operateursnot': this.operateursnot,
        'operateurautre': this.operateursAutre,
        'technologies': this.technologies,
        'systemes': this.systemeUrlType
      }
      axios.get('/api/v1/statistiques', {
        params: params
      })
        .then((response) => {
          if (response.data) {
            var result = response.data
            this.totalSites = result.total
            this.nbTel = result.tel
            this.nbTv = result.tnt
            this.nbRadio = result.radio
            this.nbRadioAM = result.radio.AM
            this.nbRadioFM = result.radio.FM
            this.nbRadioRNT = result.radio.RNT
            this.nbRmp = result.rmp
            this.nbFh = result.fh
            this.nbAutres = result.autres

            this.boolShowStats = true
          }
        })
        .catch(function(error) {
          console.error('communes', error)
        })
    },

    showDetail() {
      this.getDetail()
      this.boolShowDetail = true
    },

    resetDetail() {
      this.nbTelService = 0
      this.nbOrange = 0
      this.nbOrangeService = 0
      this.nbSfr = 0
      this.nbSfrService = 0
      this.nbBouygues = 0
      this.nbBouyguesService = 0
      this.nbFree = 0
      this.nbFreeService = 0
      this.operateurData = []
    },

    getDetail() {
      var params = {
        'commune': this.localisationInfo && this.localisationInfo.type === 'COM' ? this.localisationInfo.id : null,
        'departement': this.localisationInfo && this.localisationInfo.type === 'DEP' ? this.localisationInfo.id : null,
        'fauxdepartement': this.localisationInfo && this.localisationInfo.type === 'FDEP' ? this.localisationInfo.id : null,
        'region': this.localisationInfo && this.localisationInfo.type === 'REG' ? this.localisationInfo.id : null,
        'operateurs': this.operateurs,
        'operateursnot': this.operateursnot,
        'operateurautre': this.operateursAutre,
        'technologies': this.technologies,
        'systemes': this.systemeUrlType
      }
      axios.get('/api/v1/statistiques/operateur', {
        params: params
      })
        .then((response) => {
          this.resetDetail()
          if (response.data) {
            this.nbTelService = response.data.totalService
            let length = response.data.operateur.length
            for (let i = 0; i < length; i++) {
              this.operateurData.push({
                id: response.data.operateur[i].id,
                nom: response.data.operateur[i].nom,
                count: response.data.operateur[i].count,
                countEnService: this.getCountEnService(response.data.operateurService, response.data.operateur[i].id),
                code_couleur: response.data.operateur[i].code_couleur,
                ordre_affichage: response.data.operateur[i].ordre_affichage
              })
            }
          }
        })
        .catch(function(error) {
          console.error('detailOperateurError', error)
        })
    },

    hideDetail() {
      this.boolShowDetail = false
      this.boolShowTechnos = false
      this.boolShowTechnosBandes = false
      this.resetNbTechnos()
    },

    showTechnos() {
      this.boolShowTechnos = !this.boolShowTechnos
      this.boolShowTechnosBandes = this.boolShowTechnosBandes && this.boolShowTechnos ? !this.boolShowTechnosBandes : this.boolShowTechnosBandes
      if (this.boolShowTechnos) {
        this.getOperateurTechno()
      }
      this.resetNbTechnos()
    },

    getOperateurTechno() {
      var params = {
        'commune': this.localisationInfo && this.localisationInfo.type === 'COM' ? this.localisationInfo.id : null,
        'departement': this.localisationInfo && this.localisationInfo.type === 'DEP' ? this.localisationInfo.id : null,
        'fauxdepartement': this.localisationInfo && this.localisationInfo.type === 'FDEP' ? this.localisationInfo.id : null,
        'region': this.localisationInfo && this.localisationInfo.type === 'REG' ? this.localisationInfo.id : null,
        'operateurs': this.operateurs,
        'operateursnot': this.operateursnot,
        'operateurautre': this.operateursAutre,
        'technologies': this.technologies,
        'systemes': this.systemeUrlType
      }
      if (this.boolShowTechnos) {
        axios.get('/api/v1/statistiques/operateur/technologie', {
          params: params
        })
          .then((response) => {
            if (response.data) {
              this.listeOperateurTechno = response.data.operateurTechno
            }
          })
          .catch(function(error) {
            console.error('detailOperateurError', error)
          })
      }
    },

    showTechnosBandes() {
      this.boolShowTechnosBandes = !this.boolShowTechnosBandes
      this.boolShowTechnos = this.boolShowTechnos && this.boolShowTechnosBandes ? !this.boolShowTechnos : this.boolShowTechnos
      if (this.boolShowTechnosBandes) {
        this.getOperateurTechnoBande()
      } else {
        this.resetNbTechnos()
      }
    },

    resetNbTechnos() {
      this.nb5G = 0
      this.nb4G = 0
      this.nb3G = 0
      this.nb2G = 0
      this.listeOperateurTechnoBande = []
      this.listeOperateurTechno = []
    },

    getOperateurTechnoBande() {
      var params = {
        'commune': this.localisationInfo && this.localisationInfo.type === 'COM' ? this.localisationInfo.id : null,
        'departement': this.localisationInfo && this.localisationInfo.type === 'DEP' ? this.localisationInfo.id : null,
        'fauxdepartement': this.localisationInfo && this.localisationInfo.type === 'FDEP' ? this.localisationInfo.id : null,
        'region': this.localisationInfo && this.localisationInfo.type === 'REG' ? this.localisationInfo.id : null,
        'operateurs': this.operateurs,
        'operateursnot': this.operateursnot,
        'operateurautre': this.operateursAutre,
        'technologies': this.technologies,
        'systemes': this.systemeUrlType
      }
      if (this.boolShowTechnosBandes) {
        axios.get('/api/v1/statistiques/operateur/technologieBande', {
          params: params
        })
          .then((response) => {
            if (response.data) {
              this.listeOperateurTechnoBande = response.data.operateurTechnoBande
              var self = this
              _.forEach(response.data.operateurTechnoBande, function(value, key) {
                if (value.technologie === '5G') {
                  self.nb5G++
                } else if (value.technologie === '4G') {
                  self.nb4G++
                } else if (value.technologie === '3G') {
                  self.nb3G++
                } else if (value.technologie === '2G') {
                  self.nb2G++
                }
              })
              this.technoSorted = this.technologies.slice()
              this.technoSorted.reverse()
            }
          })
          .catch(function(error) {
            console.error('detailOperateurError', error)
          })
      }
    },

    getParityTechno(techno) {
      return this.technoSorted.findIndex((element) => element === techno) % 2 === 0
    },

    disableFilterLocalisation() {
      this.$store.state.localisation.active = false
      this.$store.state.localisation.filter = null
    },

    reloadStats() {
      if (this.boolShowStats) {
        this.getStatistiques()
      }
      if (this.boolShowDetail) {
        this.getDetail()
      }
      if (this.boolShowTechnos) {
        this.getOperateurTechno()
      }
      if (this.boolShowTechnosBandes) {
        this.resetNbTechnos()
        this.getOperateurTechnoBande()
      }
    },
    /**
     * Renvoie une couleur en hex plus clair
     * @param {*} hexColor la couleur en hex
     * @param {*} brightnessPercentage pourcentage de luminosité
     */
    brighterHexColor(hexColor, brightnessPercentage) {
      // Supprime le caractère '#' s'il est présent
      hexColor = hexColor.replace('#', '')

      // Convertit la couleur hexadécimale en valeurs RGB
      let r = parseInt(hexColor.substring(0, 2), 16)
      let g = parseInt(hexColor.substring(2, 4), 16)
      let b = parseInt(hexColor.substring(4, 6), 16)

      // Calcule l'incrément de luminosité en fonction du pourcentage
      const brightnessIncrement = Math.round((brightnessPercentage / 100) * 255)

      // Augmente les valeurs RGB pour rendre la couleur plus lumineuse
      r = Math.min(r + brightnessIncrement, 255)
      g = Math.min(g + brightnessIncrement, 255)
      b = Math.min(b + brightnessIncrement, 255)

      // Convertit les nouvelles valeurs RGB en hexadécimal
      const brighterHex = '#' + ((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')

      return brighterHex
    },
    /**
     * Permet d'jouter l'opacité à la couluer
     * @param {*} color couleur
     * @param {*} opacity opacité entre 0 et 1
     */
    addAlpha(color, opacity) {
      color = this.brighterHexColor(color, 30)
      const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255)
      return color + _opacity.toString(16).toUpperCase()
    },
    /**
     * Permet d'exporter les statistiques dans un fichier csv
     */
    exportStatsDataToCsv() {
      // On peut exporter quatre fichiers selon le désire de l'utilisateur

      let data = []
      let fileName = this.$store.state.localisation.filter.nom.toLowerCase() + '_'
      // Globale
      if (!this.boolShowDetail) {
        data = [
          ['totalSites', 'nbTel', 'nbTv', 'nbRadio', 'nbRmp', 'nbFh', 'nbAutres'],
          [this.totalSites, this.nbTel, this.nbTv, this.nbRadio, this.nbRmp, this.nbFh, this.nbAutres]
        ]

        fileName = fileName + 'stats'
      } else if (this.boolShowTechnos) { // Détails avec téchnos
        let headers = ['', ...Array.from(this.operateurData).flatMap((op) => [op.nom + ' Total', op.nom + ' En service'])]
        data.push(headers)

        this.listeOperateurTechno.forEach(techno => {
          let row = [techno.technologie]
          this.operateurData.forEach(op => {
            let stats = techno.operateurCount.find(stat => stat.operateur === op.id)
            if (stats) {
              row.push(stats.count)
              row.push(stats.countService)
            } else {
              row.push('')
              row.push('')
            }
          })
          data.push(row)
        })

        fileName = fileName + 'stats_details_technos'
      } else if (this.boolShowTechnosBandes) { // Détails aves technos et bandes
        let headers = ['', ...Array.from(this.operateurData).flatMap((op) => [op.nom + ' Total', op.nom + ' En service'])]
        data.push(headers)

        this.listeOperateurTechnoBande.forEach(techno => {
          let row = [techno.bande]
          this.operateurData.forEach(op => {
            let stats = techno.operateurCount.find(stat => stat.operateur === op.id)
            if (stats) {
              row.push(stats.count)
              row.push(stats.countService)
            } else {
              row.push('')
              row.push('')
            }
          })
          data.push(row)
        })

        fileName = fileName + 'stats_details_technos_frequencies'
      } else { // Détails
        let headers = ['', ...Array.from(this.operateurData).map((op) => op.nom)]
        data.push(headers)
        // total sites
        let total = ['Total des sites', ...Array.from(this.operateurData).map((op) => op.count)]
        data.push(total)
        // en service
        let enService = ['En service', ...Array.from(this.operateurData).map((op) => op.countEnService)]
        data.push(enService)

        fileName = fileName + 'stats_details'
      }

      // On exporte les données en CSV avec ';' comme séparateur
      new FileExporter().exportFromData(data.map(a => a.join(';')).join('\n'), fileName)
    },
    findDataOperateur(data, operateur) {
      let opData = data.find(o => o.operateur === operateur.id)
      if (opData) {
        return opData
      } else {
        return false
      }
    },
    getCountEnService(data, id) {
      let enService = (data.find(o => o.id === id))
      if (enService) {
        return enService.count
      }
      return 0
    },

    closeDropdownOnClickOutside(event) {
      const dropdown = this.$refs.dropdown
      if (!dropdown.contains(event.target) && this.isDropdownOpen === true) {
        // Fermeture de la barre de défilement des territoires d'outre-mer
        this.isDropdownOpen = false
      }
    }
  }
}
</script>

<style>
.sidebar_block.mesures .vue-slider-component .vue-slider-tooltip {
  background-color: #cc3399;
  border-color: #cc3399;
}

.sidebar_block.mesures .vue-slider-component .vue-slider-dot,
.sidebar_block.mesures .vue-slider-process {
  background-color: #cc3399;
}

.sidebar_block.mesures .vue-slider-piecewise-label {
  color: #afafaf;
  font-style: italic;
}

.sidebar_block.mesures .parameter.sonde .vue-slider-dot {
  border-radius: 0;
}

.sidebar_block.simulations .vue-slider-component .vue-slider-tooltip {
  background-color: #482878;
  border-color: #482878;
}

.sidebar_block.simulations .vue-slider-component .vue-slider-dot,
.sidebar_block.simulations .vue-slider-process {
  background-color: #482878;
}

.sidebar_block.simulations .vue-slider-piecewise-label {
  color: #afafaf;
  font-style: italic;
}

.sidebar_block.simulations .parameter.sonde .vue-slider-dot {
  border-radius: 0;
}

.vue-slider-component .vue-slider-dot {
  box-shadow: none;
}

/*#location-marker {
  width: 20px;
  height: 20px;
  border: 1px solid #088;
  border-radius: 10px;
  background-color: #0FF;
  opacity: 0.5;
}*/

#location-marker:before {
  content: "⛳";
  font-size: 1.5em;
  margin-bottom: 0.5em;
  color: #ff002d;
}

#lonlat-marker:before {
  content: "⊡";
  font-size: 3em;
  margin-bottom: 0.5em;
  color: #ff002d;
  left: -20px;
  top: -32px;
  position: absolute;
}

.ol-dragzoom {
  border-color: #007db8;
  border-width: 1px;
  background-color: rgba(255, 255, 255, 0.4);
}

.ol-zoom {
  display: none;
}

/* Positionnement des contrôles sur la carte */

/*.v-autocomplete.adresse,*/

.right_content .tools button,
.bottom_left button,
.scale *,
.bottom_left .date_maj {
  z-index: 90;
}

.sidebar_button {
  z-index: 92;
}

.top_left,
.search_bar.map_search_bar .icon_location,
.sidebar {
  z-index: 90;
}

.footer.active {
  max-height: 100%;
}

/* TODO voir si besoin de généraliser avec une classe supplémentaire */

div.control-holder {
  z-index: 90;
}
.tools>*.control-holder-fullscreen {
  margin-left: 0;
  margin-bottom: 0;
}
.tools div.ol-control.ol-full-screen {
  margin-left: 10px;
}
@media screen and (max-width: 1024px) {
  .tools div.ol-control.ol-full-screen {
    margin-bottom: 10px;
  }
}

.tools div.ol-control {
  position: relative;
  padding: 0;
  margin: 0;
  right: 0;
  top: 0;
}

div.ol-control button {
  border-radius: 0;
  margin: 0;
}

.ol-control button:focus {
  background-color: #007abc;
}

.ol-control button:hover {
  background-color: #282828;
}

div.ol-attribution,
div.ol-attribution.ol-uncollapsible,
div.ol-attribution:hover {
  top: 60px;
  right: 15px;
  background-color: transparent;
  border-radius: 0;
}

div.ol-attribution button {
  background-color: #007abc;
  width: 35px;
  height: 35px;
}

/* Fullscreen masqué si application installée */
@media all and (display-mode: fullscreen) {
  .control-holder-fullscreen {
    display: none;
  }
}

/* Gestion du fullscreen sur une hauteur 100% */

.ol-map:-moz-full-screen {
  height: 100%;
  max-height: unset;
}

.ol-map:-webkit-full-screen {
  height: 100%;
  max-height: unset;
}

.ol-map:-ms-fullscreen {
  height: 100%;
  max-height: unset;
}

.ol-map:fullscreen {
  height: 100%;
  max-height: unset;
}

.ol-map .warning {
  text-align: center;
  bottom: 0px;
  font-style: italic;
  background-color: white;
  padding-left: 10px;
  padding-right: 10px;
  line-height: 2.4;
  border: solid 1px #282828;
  z-index: 1000;
  /* En bas, centré */
  height: 33px;
  position: fixed;
  min-width:200px;
  left: calc(50%);
  transform: translateX(-50%);
}

.modal-dialog-content {
  min-height: 80px;
  padding: 0;
  min-width: 400px;
}

.downloadmap-dialog-content {
  margin: 20px 40px 50px 20px;
}

.savemap-dialog-content {
  padding: 30px;
}

.cr-login-error-hidden {
  display: none;
}

.modal-dialog-buttons {
  padding: 5px 5px 5px 5px;
  height: 22px;
}

.modal-dialog-buttons .enregistrer {
  border: medium none;
  height: 22px;
  background-color: #007abc;
  color: #fff;
  position: absolute;
  right: 10px;
}

.modal-dialog-buttons .fermer {
  border: medium none;
  height: 22px;
  background-color: #007abc;
  color: #fff;
  position: absolute;
  left: 10px;
}

div.tools_modal_content {
  background-color: #fefefe;
  margin: 20% auto;
  background: #fff;
  border: 3px solid #007abc;
  width: fit-content;
  position: relative;
}

div.tools_modal_footer {
  background-color: #007abc;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 40px;
  position: absolute;
  width: 100%;
  bottom: 0;
}

.error_save {
  color: red;
  right: 0;
  margin-bottom: 10px;
  font-size: 0.9em;
  width: fit-content;
}

.selectExport {
  margin: 0px 10px 10px 10px;
  height: 30px;
  width: 60%;
}

.search-help-notification {
  width: auto !important;
  left: 50% !important;
  top: 50% !important;
  transform: translateX(-50%) translateY(-50%);
  -webkit-font-smoothing: subpixel-antialiased;
}

.search-help-notification .notification {
  padding: 14px;
  background-color: #fcb66f;
  border: none;
}

.search-help-notification .notification-content {
  font-style: italic;
  cursor: pointer;
}

.directionsAntennes {
  padding:10px 0 0 10px;
}

#ficheantenneContent {
  font-size: 0.8em;
  margin: 2px 2px 2px 2px;
  height: 25px;
}

#ficheantenneContent p{
  margin: 4.2px 4.2px 4.2px 4.2px;
}

.hideFicheAntenne {
  display: none;
}

.tools_modal_content_pnse {
  min-width: 26em;
  max-width: 50em;
  word-wrap: break-word;
}

.tools_modal_header_pnse {
  min-height: 20px;
}

.tools_modal_footer_pnse {
  position: relative !important;
}
</style>
